import { a as e, c as t, d as n, f as r, g as i, h as a, i as o, l as s, m as c, o as l, p as u, r as d, s as f, u as p } from "./defaultCommentEditorSchema-BkS69xQH.js";
import { a as m, c as h, i as g, o as _, r as v, s as y, t as b } from "./FloatingThreadController-DXD0P6RJ.js";
import { r as ee, t as te } from "./FloatingComposerController-KlxX35Kg.js";
import x, { Suspense as ne, createContext as re, forwardRef as ie, lazy as ae, useCallback as S, useContext as C, useEffect as w, useImperativeHandle as T, useMemo as E, useReducer as oe, useRef as D, useState as O, useSyncExternalStore as se } from "react";
import { CommentsExtension as k } from "@blocknote/core/comments";
import { DEFAULT_LINK_PROTOCOL as ce, FilePanelExtension as A, FormattingToolbarExtension as j, LinkToolbarExtension as le, ShowSelectionExtension as ue, SideMenuExtension as M, SuggestionMenu as N, TableHandlesExtension as P, VALID_LINK_PROTOCOLS as de, filterSuggestionItems as fe, getDefaultEmojiPickerItems as pe, getDefaultSlashMenuItems as me } from "@blocknote/core/extensions";
import { autoPlacement as he, autoUpdate as ge, flip as _e, offset as F, safePolygon as ve, shift as ye, size as I, useFloating as be, useTransitionStyles as xe } from "@floating-ui/react";
import { EMPTY_CELL_HEIGHT as Se, EMPTY_CELL_WIDTH as Ce, UnreachableCaseError as we, addInlineContentAttributes as Te, addInlineContentKeyboardShortcuts as Ee, addStyleAttributes as De, audioParse as Oe, blockHasType as L, camelToDataKebab as ke, createAudioBlockConfig as Ae, createFileBlockConfig as je, createImageBlockConfig as Me, createInternalInlineContentSpec as Ne, createInternalStyleSpec as Pe, createVideoBlockConfig as Fe, defaultProps as R, defaultToggledState as Ie, editorHasBlockWithType as z, fileParse as Le, filenameFromURL as Re, formatKeyboardShortcut as ze, getBlockFromPos as Be, getColspan as Ve, getInlineContentParseRules as He, getNodeById as Ue, getPageBreakSlashMenuItems as We, getRowspan as Ge, getStyleParseRules as Ke, imageParse as qe, inlineContentToNodes as Je, isTableCell as B, isTableCellSelection as Ye, mapTableCell as V, mergeCSSClasses as H, nodeToCustomInlineContent as Xe, propsToAttributes as Ze, stylePropsToAttributes as Qe, videoParse as $e } from "@blocknote/core";
import { Fragment as U, jsx as W, jsxs as G } from "react/jsx-runtime";
import { Node as et } from "@tiptap/core";
import { RiAddFill as tt, RiAlignCenter as nt, RiAlignJustify as rt, RiAlignLeft as it, RiAlignRight as at, RiBold as ot, RiChat3Line as st, RiCodeBlock as ct, RiCodeFill as lt, RiDeleteBin7Line as ut, RiDownload2Fill as dt, RiEmotionFill as ft, RiExternalLinkFill as pt, RiFile2Line as mt, RiFilmLine as ht, RiFontFamily as gt, RiH1 as K, RiH2 as q, RiH3 as J, RiH4 as _t, RiH5 as vt, RiH6 as yt, RiImage2Fill as bt, RiImageAddFill as xt, RiImageEditFill as St, RiIndentDecrease as Ct, RiIndentIncrease as wt, RiInputField as Tt, RiItalic as Et, RiLink as Dt, RiLinkUnlink as Ot, RiListCheck3 as kt, RiListOrdered as At, RiListUnordered as jt, RiMergeCellsHorizontal as Mt, RiMergeCellsVertical as Nt, RiPlayList2Fill as Pt, RiQuoteText as Ft, RiStrikethrough as It, RiSubtractLine as Lt, RiTable2 as Rt, RiText as zt, RiUnderline as Bt, RiVideoFill as Vt, RiVolumeUpFill as Ht } from "react-icons/ri";
import { AiOutlinePlus as Ut } from "react-icons/ai";
import { MdArrowDropDown as Wt, MdDragIndicator as Gt } from "react-icons/md";
import { createPortal as Kt, flushSync as qt } from "react-dom";
import { Mark as Jt, NodeViewWrapper as Yt, ReactMarkViewContext as Xt, ReactMarkViewRenderer as Zt, ReactNodeViewRenderer as Qt, useReactNodeView as $t } from "@tiptap/react";
import { createRoot as en } from "react-dom/client";
import { TbPageBreak as tn } from "react-icons/tb";
//#region src/components/Popovers/BlockPopover.tsx
var nn = (e) => {
	let { blockId: t, children: n, ...r } = e, i = c();
	return /* @__PURE__ */ W(p, {
		reference: E(() => i.transact((e) => {
			if (!t) return;
			let n = Ue(t, e.doc);
			if (!n) return;
			let { node: r } = i.prosemirrorView.domAtPos(n.posBeforeNode + 1);
			if (r instanceof Element) return { element: r };
		}), [i, t]),
		...r,
		children: t !== void 0 && n
	});
}, rn = (e) => {
	let t = s(), n = f(), r = c(), i = r.getBlock(e.blockId), [a, o] = O(""), l = S((e) => {
		o(e.currentTarget.value);
	}, []), u = S((e) => {
		e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), r.updateBlock(i.id, { props: {
			name: Re(a),
			url: a
		} }));
	}, [
		r,
		i.id,
		a
	]), d = S(() => {
		r.updateBlock(i.id, { props: {
			name: Re(a),
			url: a
		} });
	}, [
		r,
		i.id,
		a
	]);
	return /* @__PURE__ */ G(t.FilePanel.TabPanel, {
		className: "bn-tab-panel",
		children: [/* @__PURE__ */ W(t.FilePanel.TextInput, {
			className: "bn-text-input",
			placeholder: n.file_panel.embed.url_placeholder,
			value: a,
			onChange: l,
			onKeyDown: u,
			"data-test": "embed-input"
		}), /* @__PURE__ */ W(t.FilePanel.Button, {
			className: "bn-button",
			onClick: d,
			"data-test": "embed-input-button",
			children: n.file_panel.embed.embed_button[i.type] || n.file_panel.embed.embed_button.file
		})]
	});
}, an = (e) => {
	let t = s(), n = f(), { setLoading: r } = e, i = c(), a = i.getBlock(e.blockId), [o, l] = O(!1);
	w(() => {
		o && setTimeout(() => {
			l(!1);
		}, 3e3);
	}, [o]);
	let u = S((t) => {
		if (t === null) return;
		async function n(t) {
			if (r(!0), i.uploadFile !== void 0) try {
				let n = await i.uploadFile(t, e.blockId);
				typeof n == "string" && (n = { props: {
					name: t.name,
					url: n
				} }), i.updateBlock(e.blockId, n);
			} catch {
				l(!0);
			} finally {
				r(!1);
			}
		}
		n(t);
	}, [
		e.blockId,
		i,
		r
	]), d = i.schema.blockSpecs[a.type], p = d.implementation.meta?.fileBlockAccept?.length ? d.implementation.meta.fileBlockAccept.join(",") : "*/*";
	return /* @__PURE__ */ G(t.FilePanel.TabPanel, {
		className: "bn-tab-panel",
		children: [/* @__PURE__ */ W(t.FilePanel.FileInput, {
			className: "bn-file-input",
			"data-test": "upload-input",
			accept: p,
			placeholder: n.file_panel.upload.file_placeholder[a.type] || n.file_panel.upload.file_placeholder.file,
			value: null,
			onChange: u
		}), o && /* @__PURE__ */ W("div", {
			className: "bn-error-text",
			children: n.file_panel.upload.upload_error
		})]
	});
}, on = (e) => {
	let t = s(), n = f(), r = c(), [i, a] = O(!1), o = e.tabs ?? [...r.uploadFile === void 0 ? [] : [{
		name: n.file_panel.upload.title,
		tabPanel: /* @__PURE__ */ W(an, {
			blockId: e.blockId,
			setLoading: a
		})
	}], {
		name: n.file_panel.embed.title,
		tabPanel: /* @__PURE__ */ W(rn, { blockId: e.blockId })
	}], [l, u] = O(e.defaultOpenTab || o[0].name);
	return /* @__PURE__ */ W(t.FilePanel.Root, {
		className: "bn-panel",
		defaultOpenTab: l,
		openTab: l,
		setOpenTab: u,
		tabs: o,
		loading: i
	});
}, sn = (e) => {
	let t = c(), n = r(A), i = u(A), a = E(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: !!i,
			onOpenChange: (e, r, i) => {
				e || n.closeMenu(), i === "escape-key" && t.focus();
			},
			middleware: [F(10), _e()],
			...e.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 90 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		i,
		t,
		n,
		e.floatingUIOptions
	]), o = e.filePanel || on;
	return /* @__PURE__ */ W(nn, {
		blockId: i,
		...a,
		children: i && /* @__PURE__ */ W(o, { blockId: i })
	});
}, cn = {
	bold: ot,
	italic: Et,
	underline: Bt,
	strike: It,
	code: lt
};
function ln(e, t) {
	return e in t.schema.styleSchema && t.schema.styleSchema[e].type === e && t.schema.styleSchema[e].propSchema === "boolean";
}
var Y = (e) => {
	let t = f(), n = s(), r = c(), i = l({
		editor: r,
		selector: ({ editor: t }) => {
			if (!(!t.isEditable || !ln(e.basicTextStyle, t) || !(t.getSelection()?.blocks || [t.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return e.basicTextStyle in t.getActiveStyles() ? { active: !0 } : { active: !1 };
		}
	}), a = S((e) => {
		r.focus(), r.toggleStyles({ [e]: !0 });
	}, [r, e]);
	if (i === void 0) return null;
	let o = cn[e.basicTextStyle];
	return /* @__PURE__ */ W(n.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": e.basicTextStyle,
		onClick: () => a(e.basicTextStyle),
		isSelected: i.active,
		label: t.formatting_toolbar[e.basicTextStyle].tooltip,
		mainTooltip: t.formatting_toolbar[e.basicTextStyle].tooltip,
		secondaryTooltip: ze(t.formatting_toolbar[e.basicTextStyle].secondary_tooltip, t.generic.ctrl_shortcut),
		icon: /* @__PURE__ */ W(o, {})
	});
}, un = (e) => {
	let t = e.textColor || "default", n = e.backgroundColor || "default", r = e.size || 16;
	return /* @__PURE__ */ W("div", {
		className: "bn-color-icon",
		"data-background-color": n,
		"data-text-color": t,
		style: E(() => ({
			pointerEvents: "none",
			fontSize: (r * .75).toString() + "px",
			height: r.toString() + "px",
			lineHeight: r.toString() + "px",
			textAlign: "center",
			width: r.toString() + "px"
		}), [r]),
		children: "A"
	});
}, dn = [
	"default",
	"gray",
	"brown",
	"red",
	"orange",
	"yellow",
	"green",
	"blue",
	"purple",
	"pink"
], fn = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ G(U, { children: [/* @__PURE__ */ W(() => e.text ? /* @__PURE__ */ G(U, { children: [/* @__PURE__ */ W(t.Generic.Menu.Label, { children: n.color_picker.text_title }), dn.map((r) => /* @__PURE__ */ W(t.Generic.Menu.Item, {
		onClick: () => {
			e.onClick && e.onClick(), e.text.setColor(r);
		},
		"data-test": "text-color-" + r,
		icon: /* @__PURE__ */ W(un, {
			textColor: r,
			size: e.iconSize
		}),
		checked: e.text.color === r,
		children: n.color_picker.colors[r]
	}, "text-color-" + r))] }) : null, {}), /* @__PURE__ */ W(() => e.background ? /* @__PURE__ */ G(U, { children: [/* @__PURE__ */ W(t.Generic.Menu.Label, { children: n.color_picker.background_title }), dn.map((r) => /* @__PURE__ */ W(t.Generic.Menu.Item, {
		onClick: () => {
			e.onClick && e.onClick(), e.background.setColor(r);
		},
		"data-test": "background-color-" + r,
		icon: /* @__PURE__ */ W(un, {
			backgroundColor: r,
			size: e.iconSize
		}),
		checked: e.background.color === r,
		children: n.color_picker.colors[r]
	}, "background-color-" + r))] }) : null, {})] });
};
//#endregion
//#region src/components/FormattingToolbar/DefaultButtons/ColorStyleButton.tsx
function pn(e, t) {
	return `${e}Color` in t.schema.styleSchema && t.schema.styleSchema[`${e}Color`].type === `${e}Color` && t.schema.styleSchema[`${e}Color`].propSchema === "string";
}
var mn = () => {
	let e = s(), t = f(), n = c(), r = pn("text", n), i = pn("background", n), a = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0)) return;
			let t = pn("text", e), n = pn("background", e);
			if (!(!t && !n)) return {
				textColor: t ? e.getActiveStyles().textColor || "default" : void 0,
				backgroundColor: n ? e.getActiveStyles().backgroundColor || "default" : void 0
			};
		}
	}), o = S((e) => {
		if (!r) throw Error("Tried to set text color, but style does not exist in editor schema.");
		e === "default" ? n.removeStyles({ textColor: e }) : n.addStyles({ textColor: e }), setTimeout(() => {
			n.focus();
		});
	}, [n, r]), u = S((e) => {
		if (!i) throw Error("Tried to set background color, but style does not exist in editor schema.");
		e === "default" ? n.removeStyles({ backgroundColor: e }) : n.addStyles({ backgroundColor: e }), setTimeout(() => {
			n.focus();
		});
	}, [i, n]);
	return a === void 0 ? null : /* @__PURE__ */ G(e.Generic.Menu.Root, { children: [/* @__PURE__ */ W(e.Generic.Menu.Trigger, { children: /* @__PURE__ */ W(e.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": "colors",
		label: t.formatting_toolbar.colors.tooltip,
		mainTooltip: t.formatting_toolbar.colors.tooltip,
		icon: /* @__PURE__ */ W(un, {
			textColor: a.textColor,
			backgroundColor: a.backgroundColor,
			size: 20
		})
	}) }), /* @__PURE__ */ W(e.Generic.Menu.Dropdown, {
		className: "bn-menu-dropdown bn-color-picker-dropdown",
		children: /* @__PURE__ */ W(fn, {
			text: a.textColor ? {
				color: a.textColor,
				setColor: o
			} : void 0,
			background: a.backgroundColor ? {
				color: a.backgroundColor,
				setColor: u
			} : void 0
		})
	})] });
}, hn = (e) => {
	for (let t of de) if (e.startsWith(t)) return e;
	return `${ce}://${e}`;
}, gn = (e) => {
	let t = s(), n = f(), { editLink: i } = r(le), { url: a, text: o, showTextField: c } = e, [l, u] = O(a), [d, p] = O(o);
	w(() => {
		u(a), p(o);
	}, [o, a]);
	let m = S((t) => {
		t.key === "Enter" && !t.nativeEvent.isComposing && (t.preventDefault(), i(hn(l), d, e.range.from), e.setToolbarOpen?.(!1), e.setToolbarPositionFrozen?.(!1));
	}, [
		i,
		l,
		d,
		e
	]), h = S((e) => u(e.currentTarget.value), []), g = S((e) => p(e.currentTarget.value), []), _ = S(() => {
		i(hn(l), d, e.range.from), e.setToolbarOpen?.(!1), e.setToolbarPositionFrozen?.(!1);
	}, [
		i,
		l,
		d,
		e
	]);
	return /* @__PURE__ */ G(t.Generic.Form.Root, { children: [/* @__PURE__ */ W(t.Generic.Form.TextInput, {
		className: "bn-text-input",
		name: "url",
		icon: /* @__PURE__ */ W(Dt, {}),
		autoFocus: !0,
		placeholder: n.link_toolbar.form.url_placeholder,
		value: l,
		onKeyDown: m,
		onChange: h,
		onSubmit: _
	}), c !== !1 && /* @__PURE__ */ W(t.Generic.Form.TextInput, {
		className: "bn-text-input",
		name: "title",
		icon: /* @__PURE__ */ W(zt, {}),
		placeholder: n.link_toolbar.form.title_placeholder,
		value: d,
		onKeyDown: m,
		onChange: g,
		onSubmit: _
	})] });
};
//#endregion
//#region src/components/FormattingToolbar/DefaultButtons/CreateLinkButton.tsx
function _n(e) {
	return "link" in e.schema.inlineContentSchema && e.schema.inlineContentSchema.link === "link";
}
var vn = () => {
	let t = c(), n = e(), i = s(), a = f(), o = r(j), { showSelection: u } = r(ue), [d, p] = O(!1);
	w(() => (u(d, "createLinkButton"), () => u(!1, "createLinkButton")), [d, u]);
	let m = l({
		editor: t,
		selector: ({ editor: e }) => {
			if (!(!e.isEditable || !_n(e) || Ye(e.prosemirrorState.selection) || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return {
				url: e.getSelectedLinkUrl(),
				text: e.getSelectedText(),
				range: {
					from: e.prosemirrorState.selection.from,
					to: e.prosemirrorState.selection.to
				}
			};
		}
	});
	return w(() => {
		p(!1);
	}, [m]), w(() => {
		let e = (e) => {
			(e.ctrlKey || e.metaKey) && e.key === "k" && (p(!0), e.preventDefault());
		};
		return n?.addEventListener("keydown", e), () => {
			n?.removeEventListener("keydown", e);
		};
	}, [n]), m === void 0 ? null : /* @__PURE__ */ G(i.Generic.Popover.Root, {
		open: d,
		onOpenChange: p,
		children: [/* @__PURE__ */ W(i.Generic.Popover.Trigger, { children: /* @__PURE__ */ W(i.FormattingToolbar.Button, {
			className: "bn-button",
			"data-test": "createLink",
			label: a.formatting_toolbar.link.tooltip,
			mainTooltip: a.formatting_toolbar.link.tooltip,
			secondaryTooltip: ze(a.formatting_toolbar.link.secondary_tooltip, a.generic.ctrl_shortcut),
			icon: /* @__PURE__ */ W(Dt, {}),
			onClick: () => p((e) => !e)
		}) }), /* @__PURE__ */ W(i.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ W(gn, {
				url: m.url || "",
				text: m.text,
				range: m.range,
				showTextField: !1,
				setToolbarOpen: (e) => o.store.setState(e)
			})
		})]
	});
}, yn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, {
				url: "string",
				caption: "string"
			})) return n;
		}
	}), [i, a] = O(!1), o = S((e) => {
		r !== void 0 && z(n, r.type, { caption: "string" }) && n.updateBlock(r.id, { props: { caption: e.currentTarget.value } });
	}, [r, n]), u = S((e) => {
		e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), a(!1));
	}, []);
	return r === void 0 ? null : /* @__PURE__ */ G(t.Generic.Popover.Root, {
		open: i,
		onOpenChange: a,
		children: [/* @__PURE__ */ W(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ W(t.FormattingToolbar.Button, {
			className: "bn-button",
			label: e.formatting_toolbar.file_caption.tooltip,
			mainTooltip: e.formatting_toolbar.file_caption.tooltip,
			icon: /* @__PURE__ */ W(Tt, {}),
			onClick: () => a((e) => !e)
		}) }), /* @__PURE__ */ W(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ W(t.Generic.Form.Root, { children: /* @__PURE__ */ W(t.Generic.Form.TextInput, {
				name: "file-caption",
				icon: /* @__PURE__ */ W(Tt, {}),
				value: r.props.caption,
				autoFocus: !0,
				placeholder: e.formatting_toolbar.file_caption.input_placeholder,
				onKeyDown: u,
				onChange: o
			}) })
		})]
	});
}, bn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, { url: "string" })) return n;
		}
	}), i = S(() => {
		r !== void 0 && (n.focus(), n.removeBlocks([r.id]));
	}, [r, n]);
	return r === void 0 ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.file_delete.tooltip[r.type] || e.formatting_toolbar.file_delete.tooltip.file,
		mainTooltip: e.formatting_toolbar.file_delete.tooltip[r.type] || e.formatting_toolbar.file_delete.tooltip.file,
		icon: /* @__PURE__ */ W(ut, {}),
		onClick: i
	});
}, xn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, {
				url: "string",
				name: "string"
			})) return n;
		}
	}), [i, a] = O(!1), o = S((e) => {
		r !== void 0 && z(n, r.type, { name: "string" }) && n.updateBlock(r.id, { props: { name: e.currentTarget.value } });
	}, [r, n]), u = S((e) => {
		e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), a(!1));
	}, []);
	return r === void 0 ? null : /* @__PURE__ */ G(t.Generic.Popover.Root, {
		open: i,
		onOpenChange: a,
		children: [/* @__PURE__ */ W(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ W(t.FormattingToolbar.Button, {
			className: "bn-button",
			label: e.formatting_toolbar.file_rename.tooltip[r.type] || e.formatting_toolbar.file_rename.tooltip.file,
			mainTooltip: e.formatting_toolbar.file_rename.tooltip[r.type] || e.formatting_toolbar.file_rename.tooltip.file,
			icon: /* @__PURE__ */ W(gt, {}),
			onClick: () => a((e) => !e)
		}) }), /* @__PURE__ */ W(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ W(t.Generic.Form.Root, { children: /* @__PURE__ */ W(t.Generic.Form.TextInput, {
				name: "file-name",
				icon: /* @__PURE__ */ W(gt, {}),
				value: r.props.name,
				autoFocus: !0,
				placeholder: e.formatting_toolbar.file_rename.input_placeholder[r.type] || e.formatting_toolbar.file_rename.input_placeholder.file,
				onKeyDown: u,
				onChange: o
			}) })
		})]
	});
}, Sn = () => {
	let e = f(), t = s(), n = l({
		editor: c(),
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, { url: "string" })) return n;
		}
	});
	return n === void 0 ? null : /* @__PURE__ */ G(t.Generic.Popover.Root, {
		position: "bottom",
		children: [/* @__PURE__ */ W(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ W(t.FormattingToolbar.Button, {
			className: "bn-button",
			mainTooltip: e.formatting_toolbar.file_replace.tooltip[n.type] || e.formatting_toolbar.file_replace.tooltip.file,
			label: e.formatting_toolbar.file_replace.tooltip[n.type] || e.formatting_toolbar.file_replace.tooltip.file,
			icon: /* @__PURE__ */ W(St, {})
		}) }), /* @__PURE__ */ W(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-panel-popover",
			variant: "panel-popover",
			children: /* @__PURE__ */ W(on, { blockId: n.id })
		})]
	});
}, Cn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!(!e.isEditable || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return { canNestBlock: e.canNestBlock() };
		}
	}), i = S(() => {
		r !== void 0 && r.canNestBlock && (n.focus(), n.nestBlock());
	}, [n, r]);
	return r === void 0 ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": "nestBlock",
		onClick: i,
		isDisabled: !r.canNestBlock,
		label: e.formatting_toolbar.nest.tooltip,
		mainTooltip: e.formatting_toolbar.nest.tooltip,
		secondaryTooltip: ze(e.formatting_toolbar.nest.secondary_tooltip, e.generic.ctrl_shortcut),
		icon: /* @__PURE__ */ W(wt, {})
	});
}, wn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!(!e.isEditable || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return { canUnnestBlock: e.canUnnestBlock() };
		}
	}), i = S(() => {
		r !== void 0 && r.canUnnestBlock && (n.focus(), n.unnestBlock());
	}, [n, r]);
	return r === void 0 ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": "unnestBlock",
		onClick: i,
		isDisabled: !r.canUnnestBlock,
		label: e.formatting_toolbar.unnest.tooltip,
		mainTooltip: e.formatting_toolbar.unnest.tooltip,
		secondaryTooltip: ze(e.formatting_toolbar.unnest.secondary_tooltip, e.generic.ctrl_shortcut),
		icon: /* @__PURE__ */ W(Ct, {})
	});
}, Tn = (e) => [
	{
		name: e.slash_menu.paragraph.title,
		type: "paragraph",
		icon: zt
	},
	{
		name: e.slash_menu.heading.title,
		type: "heading",
		props: {
			level: 1,
			isToggleable: !1
		},
		icon: K
	},
	{
		name: e.slash_menu.heading_2.title,
		type: "heading",
		props: {
			level: 2,
			isToggleable: !1
		},
		icon: q
	},
	{
		name: e.slash_menu.heading_3.title,
		type: "heading",
		props: {
			level: 3,
			isToggleable: !1
		},
		icon: J
	},
	{
		name: e.slash_menu.heading_4.title,
		type: "heading",
		props: {
			level: 4,
			isToggleable: !1
		},
		icon: _t
	},
	{
		name: e.slash_menu.heading_5.title,
		type: "heading",
		props: {
			level: 5,
			isToggleable: !1
		},
		icon: vt
	},
	{
		name: e.slash_menu.heading_6.title,
		type: "heading",
		props: {
			level: 6,
			isToggleable: !1
		},
		icon: yt
	},
	{
		name: e.slash_menu.toggle_heading.title,
		type: "heading",
		props: {
			level: 1,
			isToggleable: !0
		},
		icon: K
	},
	{
		name: e.slash_menu.toggle_heading_2.title,
		type: "heading",
		props: {
			level: 2,
			isToggleable: !0
		},
		icon: q
	},
	{
		name: e.slash_menu.toggle_heading_3.title,
		type: "heading",
		props: {
			level: 3,
			isToggleable: !0
		},
		icon: J
	},
	{
		name: e.slash_menu.quote.title,
		type: "quote",
		icon: Ft
	},
	{
		name: e.slash_menu.toggle_list.title,
		type: "toggleListItem",
		icon: Pt
	},
	{
		name: e.slash_menu.bullet_list.title,
		type: "bulletListItem",
		icon: jt
	},
	{
		name: e.slash_menu.numbered_list.title,
		type: "numberedListItem",
		icon: At
	},
	{
		name: e.slash_menu.check_list.title,
		type: "checkListItem",
		icon: kt
	}
], En = (e) => {
	let t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => e.getSelection()?.blocks || [e.getTextCursorPosition().block]
	}), i = r[0], a = E(() => (e.items || Tn(n.dictionary)).filter((e) => z(n, e.type, Object.fromEntries(Object.entries(e.props || {}).map(([e, t]) => [e, typeof t])))), [n, e.items]), o = E(() => a.map((e) => {
		let t = e.icon, a = e.type === i.type, o = Object.entries(e.props || {}).filter(([e, t]) => t !== i.props[e]).length === 0;
		return {
			text: e.name,
			icon: /* @__PURE__ */ W(t, { size: 16 }),
			onClick: () => {
				n.focus(), n.transact(() => {
					for (let t of r) n.updateBlock(t, {
						type: e.type,
						props: e.props
					});
				});
			},
			isSelected: a && o
		};
	}), [
		n,
		a,
		i.props,
		i.type,
		r
	]);
	return !E(() => o.find((e) => e.isSelected) !== void 0, [o]) || !n.isEditable ? null : /* @__PURE__ */ W(t.FormattingToolbar.Select, {
		className: "bn-select",
		items: o
	});
}, Dn = () => {
	let e = f(), t = s(), n = r("comments"), { store: i } = r(j), a = S(() => {
		n.startPendingComment(), i.setState(!1);
	}, [n, i]);
	return /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.comment.tooltip,
		mainTooltip: e.formatting_toolbar.comment.tooltip,
		icon: /* @__PURE__ */ W(st, {}),
		onClick: a
	});
}, On = () => c().getExtension("comments") ? /* @__PURE__ */ W(Dn, {}) : null, kn = () => {
	let e = f(), t = s(), n = c(), r = S(() => {
		n._tiptapEditor.chain().focus().addPendingComment().run();
	}, [n]);
	return !n._tiptapEditor.commands.addPendingComment || !n.isEditable ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.comment.tooltip,
		mainTooltip: e.formatting_toolbar.comment.tooltip,
		icon: /* @__PURE__ */ W(st, {}),
		onClick: r
	});
};
//#endregion
//#region src/util/sanitizeUrl.ts
function An(e, t) {
	try {
		let n = new URL(e, t);
		if (n.protocol !== "javascript:") return n.href;
	} catch {}
	return "#";
}
//#endregion
//#region src/components/FormattingToolbar/DefaultButtons/FileDownloadButton.tsx
var jn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, { url: "string" })) return n;
		}
	}), i = S(() => {
		r !== void 0 && (n.focus(), n.resolveFileUrl ? n.resolveFileUrl(r.props.url).then((e) => window.open(An(e, window.location.href))) : window.open(An(r.props.url, window.location.href)));
	}, [r, n]);
	return r === void 0 ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.file_download.tooltip[r.type] || e.formatting_toolbar.file_download.tooltip.file,
		mainTooltip: e.formatting_toolbar.file_download.tooltip[r.type] || e.formatting_toolbar.file_download.tooltip.file,
		icon: /* @__PURE__ */ W(dt, {}),
		onClick: i
	});
}, Mn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, {
				url: "string",
				showPreview: "boolean"
			})) return n;
		}
	}), i = S(() => {
		r !== void 0 && z(n, r.type, { showPreview: "boolean" }) && n.updateBlock(r.id, { props: { showPreview: !r.props.showPreview } });
	}, [r, n]);
	return r === void 0 ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: "Toggle preview",
		mainTooltip: e.formatting_toolbar.file_preview_toggle.tooltip,
		icon: /* @__PURE__ */ W(xt, {}),
		isSelected: r.props.showPreview,
		onClick: i
	});
}, Nn = () => {
	let e = f(), t = s(), n = c(), i = r(P), a = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable || !e.settings.tables.splitCells) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (n.type === "table") return { mergeDirection: i.getMergeDirection(n) };
		}
	}), o = S(() => {
		i?.mergeCells();
	}, [i]);
	return a === void 0 ? null : /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.table_cell_merge.tooltip,
		mainTooltip: e.formatting_toolbar.table_cell_merge.tooltip,
		icon: a.mergeDirection === "horizontal" ? /* @__PURE__ */ W(Mt, {}) : /* @__PURE__ */ W(Nt, {}),
		onClick: o
	});
}, Pn = () => c().getExtension(P) ? /* @__PURE__ */ W(Nn, {}) : null, Fn = {
	left: it,
	center: nt,
	right: at,
	justify: rt
}, In = (e) => {
	let t = s(), n = f(), r = c(), i = l({
		editor: r,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block], n = t[0];
			if (L(n, e, n.type, { textAlignment: R.textAlignment })) return {
				textAlignment: n.props.textAlignment,
				blocks: t
			};
			if (t.length === 1 && L(n, e, "table")) return e.getExtension(P)?.getCellSelection() ? {
				textAlignment: V(n.content.rows[0].cells[0]).props.textAlignment,
				blocks: [n]
			} : void 0;
		}
	}), a = S((e) => {
		if (i !== void 0) {
			r.focus();
			for (let t of i.blocks) if (L(t, r, t.type, { textAlignment: R.textAlignment }) && z(r, t.type, { textAlignment: R.textAlignment })) r.updateBlock(t, { props: { textAlignment: e } });
			else if (t.type === "table") {
				let n = r.getExtension(P)?.getCellSelection();
				if (!n) continue;
				let i = t.content.rows.map((e) => ({
					...e,
					cells: e.cells.map((e) => V(e))
				}));
				n.cells.forEach(({ row: t, col: n }) => {
					i[t].cells[n].props.textAlignment = e;
				}), r.updateBlock(t, {
					type: "table",
					content: {
						...t.content,
						type: "tableContent",
						rows: i
					}
				}), r.setTextCursorPosition(t);
			}
		}
	}, [r, i]);
	if (i === void 0) return null;
	let o = Fn[e.textAlignment];
	return /* @__PURE__ */ W(t.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": `alignText${e.textAlignment.slice(0, 1).toUpperCase() + e.textAlignment.slice(1)}`,
		onClick: () => a(e.textAlignment),
		isSelected: i.textAlignment === e.textAlignment,
		label: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
		mainTooltip: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
		icon: /* @__PURE__ */ W(o, {})
	});
}, Ln = (e) => [
	/* @__PURE__ */ W(En, { items: e }, "blockTypeSelect"),
	/* @__PURE__ */ W(Pn, {}, "tableCellMergeButton"),
	/* @__PURE__ */ W(yn, {}, "fileCaptionButton"),
	/* @__PURE__ */ W(Sn, {}, "replaceFileButton"),
	/* @__PURE__ */ W(xn, {}, "fileRenameButton"),
	/* @__PURE__ */ W(bn, {}, "fileDeleteButton"),
	/* @__PURE__ */ W(jn, {}, "fileDownloadButton"),
	/* @__PURE__ */ W(Mn, {}, "filePreviewButton"),
	/* @__PURE__ */ W(Y, { basicTextStyle: "bold" }, "boldStyleButton"),
	/* @__PURE__ */ W(Y, { basicTextStyle: "italic" }, "italicStyleButton"),
	/* @__PURE__ */ W(Y, { basicTextStyle: "underline" }, "underlineStyleButton"),
	/* @__PURE__ */ W(Y, { basicTextStyle: "strike" }, "strikeStyleButton"),
	/* @__PURE__ */ W(In, { textAlignment: "left" }, "textAlignLeftButton"),
	/* @__PURE__ */ W(In, { textAlignment: "center" }, "textAlignCenterButton"),
	/* @__PURE__ */ W(In, { textAlignment: "right" }, "textAlignRightButton"),
	/* @__PURE__ */ W(mn, {}, "colorStyleButton"),
	/* @__PURE__ */ W(Cn, {}, "nestBlockButton"),
	/* @__PURE__ */ W(wn, {}, "unnestBlockButton"),
	/* @__PURE__ */ W(vn, {}, "createLinkButton"),
	/* @__PURE__ */ W(On, {}, "addCommentButton"),
	/* @__PURE__ */ W(kn, {}, "addTiptapCommentButton")
], Rn = (e) => /* @__PURE__ */ W(s().FormattingToolbar.Root, {
	className: "bn-toolbar bn-formatting-toolbar",
	children: e.children || Ln(e.blockTypeSelectItems)
}), zn = (e) => {
	switch (e) {
		case "left": return "top-start";
		case "center": return "top";
		case "right": return "top-end";
		default: return "top-start";
	}
}, Bn = (e) => {
	let t = c(), n = r(j, { editor: t }), i = u(j, { editor: t }), a = l({
		editor: t,
		selector: ({ editor: e }) => n.store.state ? {
			from: e.prosemirrorState.selection.from,
			to: e.prosemirrorState.selection.to
		} : void 0
	}), s = l({
		editor: t,
		selector: ({ editor: e }) => {
			let t = e.getTextCursorPosition().block;
			return L(t, e, t.type, { textAlignment: R.textAlignment }) ? zn(t.props.textAlignment) : "top-start";
		}
	}), d = E(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: i,
			onOpenChange: (e, r, i) => {
				n.store.setState(e), i === "escape-key" && t.focus();
			},
			placement: s,
			middleware: [
				F(10),
				ye(),
				_e()
			],
			...e.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 40 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		i,
		s,
		e.floatingUIOptions,
		n.store,
		t
	]), f = e.formattingToolbar || Rn;
	return /* @__PURE__ */ W(o, {
		position: a,
		...d,
		children: i && /* @__PURE__ */ W(f, {})
	});
}, Vn = (e) => {
	let t = s(), n = f(), { deleteLink: i } = r(le);
	return /* @__PURE__ */ W(t.LinkToolbar.Button, {
		className: "bn-button",
		label: n.link_toolbar.delete.tooltip,
		mainTooltip: n.link_toolbar.delete.tooltip,
		isSelected: !1,
		onClick: () => {
			i(e.range.from), e.setToolbarOpen?.(!1);
		},
		icon: /* @__PURE__ */ W(Ot, {})
	});
}, Hn = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ G(t.Generic.Popover.Root, {
		onOpenChange: e.setToolbarPositionFrozen,
		children: [/* @__PURE__ */ W(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ W(t.LinkToolbar.Button, {
			className: "bn-button",
			mainTooltip: n.link_toolbar.edit.tooltip,
			isSelected: !1,
			children: n.link_toolbar.edit.text
		}) }), /* @__PURE__ */ W(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ W(gn, {
				url: e.url,
				text: e.text,
				range: e.range,
				setToolbarOpen: e.setToolbarOpen,
				setToolbarPositionFrozen: e.setToolbarPositionFrozen
			})
		})]
	});
}, Un = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ W(t.LinkToolbar.Button, {
		className: "bn-button",
		mainTooltip: n.link_toolbar.open.tooltip,
		label: n.link_toolbar.open.tooltip,
		isSelected: !1,
		onClick: () => {
			window.open(An(e.url, window.location.href), "_blank");
		},
		icon: /* @__PURE__ */ W(pt, {})
	});
}, Wn = (e) => /* @__PURE__ */ W(s().LinkToolbar.Root, {
	className: "bn-toolbar bn-link-toolbar",
	children: e.children || /* @__PURE__ */ G(U, { children: [
		/* @__PURE__ */ W(Hn, {
			url: e.url,
			text: e.text,
			range: e.range,
			setToolbarOpen: e.setToolbarOpen,
			setToolbarPositionFrozen: e.setToolbarPositionFrozen
		}),
		/* @__PURE__ */ W(Un, { url: e.url }),
		/* @__PURE__ */ W(Vn, {
			range: e.range,
			setToolbarOpen: e.setToolbarOpen
		})
	] })
}), Gn = (t) => {
	let n = c(), [i, a] = O(!1), [o, s] = O(!1), l = e(), u = r(le), [d, f] = O(void 0);
	w(() => {
		let e = () => {
			let e = u.getLinkAtSelection();
			if (!e) {
				f(void 0), o || a(!1);
				return;
			}
			f({
				cursorType: "text",
				url: e.mark.attrs.href,
				text: e.text,
				range: e.range,
				element: u.getLinkElementAtPos(e.range.from)
			}), o || a(!0);
		}, t = (e) => {
			if (d !== void 0 && d.cursorType === "text" || !(e.target instanceof HTMLElement)) return;
			let t = u.getLinkAtElement(e.target);
			t && f({
				cursorType: "mouse",
				url: t.mark.attrs.href,
				text: t.text,
				range: t.range,
				element: u.getLinkElementAtPos(t.range.from)
			});
		}, r = n.onChange(e), i = n.onSelectionChange(e);
		return l?.addEventListener("mouseover", t), () => {
			r(), i(), l?.removeEventListener("mouseover", t);
		};
	}, [
		n,
		l,
		u,
		d,
		o
	]);
	let m = E(() => ({
		...t.floatingUIOptions,
		useFloatingOptions: {
			open: i,
			onOpenChange: (e, t, r) => {
				o || d !== void 0 && d.cursorType === "text" && r === "hover" || (r === "escape-key" && n.focus(), a(e));
			},
			placement: "top-start",
			middleware: [F(10), _e()],
			...t.floatingUIOptions?.useFloatingOptions
		},
		useHoverProps: {
			enabled: d !== void 0 && d.cursorType === "mouse",
			delay: {
				open: 250,
				close: 250
			},
			handleClose: ve(),
			...t.floatingUIOptions?.useHoverProps
		},
		focusManagerProps: {
			disabled: !0,
			...t.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 50 },
			...t.floatingUIOptions?.elementProps
		}
	}), [
		n,
		d,
		t.floatingUIOptions,
		i,
		o
	]), h = E(() => d?.element ? { element: d.element } : void 0, [d?.element]);
	if (!n.isEditable) return null;
	let g = t.linkToolbar || Wn;
	return /* @__PURE__ */ W(p, {
		reference: h,
		...m,
		children: d && /* @__PURE__ */ W(g, {
			url: d.url,
			text: d.text,
			range: d.range,
			setToolbarOpen: a,
			setToolbarPositionFrozen: s
		})
	});
}, Kn = () => {
	let e = s(), t = f(), n = c(), i = r(N), a = u(M, {
		editor: n,
		selector: (e) => e?.block
	}), o = S(() => {
		if (a === void 0) return;
		let e = a.content;
		if (e !== void 0 && Array.isArray(e) && e.length === 0) n.setTextCursorPosition(a), i.openSuggestionMenu("/");
		else {
			let e = n.insertBlocks([{ type: "paragraph" }], a, "after")[0];
			n.setTextCursorPosition(e), i.openSuggestionMenu("/");
		}
	}, [
		a,
		n,
		i
	]);
	return a === void 0 ? null : /* @__PURE__ */ W(e.SideMenu.Button, {
		className: "bn-button",
		label: t.side_menu.add_block_label,
		icon: /* @__PURE__ */ W(Ut, {
			size: 24,
			onClick: o,
			"data-test": "dragHandleAdd"
		})
	});
}, qn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	return r === void 0 || !L(r, n, r.type, { textColor: "string" }) && !L(r, n, r.type, { backgroundColor: "string" }) ? null : /* @__PURE__ */ G(t.Generic.Menu.Root, {
		position: "right",
		sub: !0,
		children: [/* @__PURE__ */ W(t.Generic.Menu.Trigger, {
			sub: !0,
			children: /* @__PURE__ */ W(t.Generic.Menu.Item, {
				className: "bn-menu-item",
				subTrigger: !0,
				children: e.children
			})
		}), /* @__PURE__ */ W(t.Generic.Menu.Dropdown, {
			sub: !0,
			className: "bn-menu-dropdown bn-color-picker-dropdown",
			children: /* @__PURE__ */ W(fn, {
				iconSize: 18,
				text: L(r, n, r.type, { textColor: "string" }) && z(n, r.type, { textColor: "string" }) ? {
					color: r.props.textColor,
					setColor: (e) => n.updateBlock(r, {
						type: r.type,
						props: { textColor: e }
					})
				} : void 0,
				background: L(r, n, r.type, { backgroundColor: "string" }) && z(n, r.type, { backgroundColor: "string" }) ? {
					color: r.props.backgroundColor,
					setColor: (e) => n.updateBlock(r, { props: { backgroundColor: e } })
				} : void 0
			})
		})]
	});
}, Jn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	return r === void 0 ? null : /* @__PURE__ */ W(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		onClick: () => {
			let e = n.getSelection()?.blocks, t = e && e.some((e) => e.id === r.id) ? e : [r];
			n.removeBlocks(t);
		},
		children: e.children
	});
}, Yn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	if (r === void 0 || r.type !== "table" || !n.settings.tables.headers) return null;
	let i = !!r.content.headerRows;
	return /* @__PURE__ */ W(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: i,
		onClick: () => {
			n.updateBlock(r, { content: {
				...r.content,
				headerRows: i ? void 0 : 1
			} });
		},
		children: e.children
	});
}, Xn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	if (r === void 0 || r.type !== "table" || !n.settings.tables.headers) return null;
	let i = !!r.content.headerCols;
	return /* @__PURE__ */ W(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: i,
		onClick: () => {
			n.updateBlock(r, { content: {
				...r.content,
				headerCols: i ? void 0 : 1
			} });
		},
		children: e.children
	});
}, Zn = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ W(t.Generic.Menu.Dropdown, {
		className: "bn-menu-dropdown bn-drag-handle-menu",
		children: e.children || /* @__PURE__ */ G(U, { children: [
			/* @__PURE__ */ W(Jn, { children: n.drag_handle.delete_menuitem }),
			/* @__PURE__ */ W(qn, { children: n.drag_handle.colors_menuitem }),
			/* @__PURE__ */ W(Yn, { children: n.drag_handle.header_row_menuitem }),
			/* @__PURE__ */ W(Xn, { children: n.drag_handle.header_column_menuitem })
		] })
	});
}, Qn = (e) => {
	let t = s(), n = f(), i = r(M), a = u(M, { selector: (e) => e?.block });
	if (a === void 0) return null;
	let o = e.dragHandleMenu || Zn;
	return /* @__PURE__ */ G(t.Generic.Menu.Root, {
		onOpenChange: (e) => {
			e ? i.freezeMenu() : i.unfreezeMenu();
		},
		position: "left",
		children: [/* @__PURE__ */ W(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ W(t.SideMenu.Button, {
			label: n.side_menu.drag_handle_label,
			draggable: !0,
			onDragStart: (e) => i.blockDragStart(e, a),
			onDragEnd: i.blockDragEnd,
			className: "bn-button",
			icon: /* @__PURE__ */ W(Gt, {
				size: 24,
				"data-test": "dragHandle"
			})
		}) }), /* @__PURE__ */ W(o, { children: e.children })]
	});
}, $n = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	}), i = E(() => {
		if (r === void 0) return {};
		let e = { "data-block-type": r.type };
		return r.type === "heading" && (e["data-level"] = r.props.level.toString()), n.schema.blockSpecs[r.type].implementation.meta?.fileBlockAccept && (r.props.url ? e["data-url"] = "true" : e["data-url"] = "false"), e;
	}, [r, n.schema.blockSpecs]);
	return /* @__PURE__ */ W(t.SideMenu.Root, {
		className: "bn-side-menu",
		...i,
		children: e.children || /* @__PURE__ */ G(U, { children: [/* @__PURE__ */ W(Kn, {}), /* @__PURE__ */ W(Qn, { dragHandleMenu: e.dragHandleMenu })] })
	});
}, er = (e) => {
	let t = c(), { show: n, block: r } = u(M, { selector: (e) => e === void 0 ? void 0 : {
		show: e.show,
		block: e.block
	} }) || {}, i = S((e, n, r) => {
		let i = !1;
		return ge(e, n, () => {
			if (!i) {
				i = !0;
				return;
			}
			t.getExtension(M)?.hideMenuIfNotFrozen();
		}, {
			ancestorScroll: !0,
			ancestorResize: !1,
			elementResize: !1,
			layoutShift: !1
		});
	}, [t]), a = E(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: n,
			placement: "left-start",
			whileElementsMounted: i,
			...e.floatingUIOptions?.useFloatingOptions
		},
		useDismissProps: {
			enabled: !1,
			...e.floatingUIOptions?.useDismissProps
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 20 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		e.floatingUIOptions,
		n,
		i
	]), o = e.sideMenu || $n;
	return /* @__PURE__ */ W(nn, {
		blockId: n ? r?.id : void 0,
		...a,
		children: r?.id && /* @__PURE__ */ W(o, {})
	});
};
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/getDefaultReactEmojiPickerItems.tsx
async function tr(e, t) {
	return (await pe(e, t)).map(({ id: e, onItemClick: t }) => ({
		id: e,
		onItemClick: t,
		icon: e
	}));
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/GridSuggestionMenu.tsx
function nr(e) {
	let t = s(), n = f(), { items: r, loadingState: i, selectedIndex: a, onItemClick: o, columns: c } = e, l = i === "loading-initial" || i === "loading" ? /* @__PURE__ */ W(t.GridSuggestionMenu.Loader, {
		className: "bn-grid-suggestion-menu-loader",
		columns: c
	}) : null, u = E(() => {
		let e = [];
		for (let n = 0; n < r.length; n++) {
			let i = r[n];
			e.push(/* @__PURE__ */ W(t.GridSuggestionMenu.Item, {
				className: "bn-grid-suggestion-menu-item",
				item: i,
				id: `bn-grid-suggestion-menu-item-${n}`,
				isSelected: n === a,
				onClick: () => o?.(i)
			}, i.id));
		}
		return e;
	}, [
		t,
		r,
		o,
		a
	]);
	return /* @__PURE__ */ G(t.GridSuggestionMenu.Root, {
		id: "bn-grid-suggestion-menu",
		columns: c,
		className: "bn-grid-suggestion-menu",
		children: [
			l,
			u,
			u.length === 0 && e.loadingState === "loaded" && /* @__PURE__ */ W(t.GridSuggestionMenu.EmptyItem, {
				className: "bn-grid-suggestion-menu-empty-item",
				columns: c,
				children: n.suggestion_menu.no_items_title
			})
		]
	});
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useCloseSuggestionMenuNoItems.ts
function rr(e, t, n, r = 3) {
	let i = D(0);
	w(() => {
		t !== void 0 && (e.length > 0 ? i.current = t.length : t.length - i.current > r && n());
	}, [
		n,
		r,
		e.length,
		t
	]);
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useLoadSuggestionMenuItems.ts
function ir(e, t) {
	let [n, r] = O([]), [i, a] = O(!1), o = D(void 0), s = D(void 0);
	return w(() => {
		let n = e;
		o.current = e, a(!0), t(e).then((e) => {
			o.current === n && (r(e), a(!1), s.current = n);
		});
	}, [e, t]), {
		items: n || [],
		usedQuery: s.current,
		loadingState: s.current === void 0 ? "loading-initial" : i ? "loading" : "loaded"
	};
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/hooks/useGridSuggestionMenuKeyboardNavigation.ts
function ar(t, n, r, i, a) {
	let o = e(t), [s, c] = O(0);
	return w(() => {
		let e = (e) => (e.key === "ArrowLeft" && (e.preventDefault(), r.length && c((s - 1 + r.length) % r.length)), e.key === "ArrowRight" && (e.preventDefault(), r.length && c((s + 1 + r.length) % r.length)), e.key === "ArrowUp" ? (e.preventDefault(), r.length && c((s - i + r.length) % r.length), !0) : e.key === "ArrowDown" ? (e.preventDefault(), r.length && c((s + i) % r.length), !0) : e.key === "Enter" && !e.isComposing ? (e.stopPropagation(), e.preventDefault(), r.length && a?.(r[s]), !0) : !1);
		return o?.addEventListener("keydown", e, !0), () => {
			o?.removeEventListener("keydown", e, !0);
		};
	}, [
		o,
		r,
		s,
		a,
		i,
		i !== void 0 && i > 1
	]), w(() => {
		c(0);
	}, [n]), { selectedIndex: r.length === 0 ? void 0 : s };
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/GridSuggestionMenuWrapper.tsx
function or(e) {
	let t = i().setContentEditableProps, n = c(), { getItems: r, gridSuggestionMenuComponent: a, query: o, clearQuery: s, closeMenu: l, onItemClick: u, columns: d } = e, f = S((e) => {
		l(), s(), u?.(e);
	}, [
		u,
		l,
		s
	]), { items: p, usedQuery: m, loadingState: h } = ir(o, r);
	rr(p, m, l);
	let { selectedIndex: g } = ar(n, o, p, d, f);
	return w(() => (t((e) => ({
		...e,
		"aria-expanded": !0,
		"aria-controls": "bn-suggestion-menu"
	})), () => {
		t((e) => ({
			...e,
			"aria-expanded": !1,
			"aria-controls": void 0
		}));
	}), [t]), w(() => (t((e) => ({
		...e,
		"aria-activedescendant": g ? "bn-suggestion-menu-item-" + g : void 0
	})), () => {
		t((e) => ({
			...e,
			"aria-activedescendant": void 0
		}));
	}), [t, g]), /* @__PURE__ */ W(a, {
		items: p,
		onItemClick: f,
		loadingState: h,
		selectedIndex: g,
		columns: d
	});
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/GridSuggestionMenuController.tsx
function sr(t) {
	let n = c(), i = e(), { triggerCharacter: a, gridSuggestionMenuComponent: o, columns: s, shouldOpen: l, minQueryLength: d, onItemClick: f, getItems: m } = t, h = E(() => f || ((e) => {
		e.onItemClick(n);
	}), [n, f]), g = E(() => m || (async (e) => await tr(n, e)), [n, m]), _ = r(N);
	w(() => {
		_.addSuggestionMenu({
			triggerCharacter: a,
			shouldOpen: l
		});
	}, [
		_,
		a,
		l
	]);
	let v = u(N), y = u(N, { selector: (e) => ({
		element: i?.firstChild || void 0,
		getBoundingClientRect: () => e?.referencePos || new DOMRect()
	}) }), b = E(() => ({
		...t.floatingUIOptions,
		useFloatingOptions: {
			open: v?.show && v?.triggerCharacter === a,
			onOpenChange: (e) => {
				e || _.closeMenu();
			},
			placement: "bottom-start",
			middleware: [
				F(10),
				he({
					allowedPlacements: ["bottom-start", "top-start"],
					padding: 10
				}),
				ye(),
				I({
					apply({ elements: e, availableHeight: t }) {
						e.floating.style.maxHeight = `${Math.max(0, t)}px`;
					},
					padding: 10
				})
			],
			...t.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...t.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			onMouseDownCapture: (e) => e.preventDefault(),
			style: { zIndex: 70 },
			...t.floatingUIOptions?.elementProps
		}
	}), [
		t.floatingUIOptions,
		v?.show,
		v?.triggerCharacter,
		_,
		a
	]);
	return !v || !v.ignoreQueryLength && d && (v.query.startsWith(" ") || v.query.length < d) ? null : /* @__PURE__ */ W(p, {
		reference: y,
		...b,
		children: a && /* @__PURE__ */ W(or, {
			query: v.query,
			closeMenu: _.closeMenu,
			clearQuery: _.clearQuery,
			getItems: g,
			columns: s,
			gridSuggestionMenuComponent: o || nr,
			onItemClick: h
		})
	});
}
//#endregion
//#region src/components/SuggestionMenu/SuggestionMenu.tsx
function cr(e) {
	let t = s(), n = f(), { items: r, loadingState: i, selectedIndex: a, onItemClick: o } = e, c = i === "loading-initial" || i === "loading" ? /* @__PURE__ */ W(t.SuggestionMenu.Loader, { className: "bn-suggestion-menu-loader" }) : null, l = E(() => {
		let e, n = [];
		for (let i = 0; i < r.length; i++) {
			let s = r[i];
			s.group !== e && (e = s.group, n.push(/* @__PURE__ */ W(t.SuggestionMenu.Label, {
				className: "bn-suggestion-menu-label",
				children: e
			}, e))), n.push(/* @__PURE__ */ W(t.SuggestionMenu.Item, {
				className: H("bn-suggestion-menu-item", s.size === "small" ? "bn-suggestion-menu-item-small" : ""),
				item: s,
				id: `bn-suggestion-menu-item-${i}`,
				isSelected: i === a,
				onClick: () => o?.(s)
			}, s.title));
		}
		return n;
	}, [
		t,
		r,
		o,
		a
	]);
	return /* @__PURE__ */ G(t.SuggestionMenu.Root, {
		id: "bn-suggestion-menu",
		className: "bn-suggestion-menu",
		children: [
			l,
			l.length === 0 && (e.loadingState === "loading" || e.loadingState === "loaded") && /* @__PURE__ */ W(t.SuggestionMenu.EmptyItem, {
				className: "bn-suggestion-menu-item",
				children: n.suggestion_menu.no_items_title
			}),
			c
		]
	});
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useSuggestionMenuKeyboardHandler.ts
function lr(e, t) {
	let [n, r] = O(0);
	return {
		selectedIndex: n,
		setSelectedIndex: r,
		handler: (i) => {
			if (i.key === "ArrowUp") return i.preventDefault(), e.length && r((n - 1 + e.length) % e.length), !0;
			if (i.key === "ArrowDown") return i.preventDefault(), e.length && r((n + 1) % e.length), !0;
			if (i.key === "PageUp") return i.preventDefault(), e.length && r(0), !0;
			if (i.key === "PageDown") return i.preventDefault(), e.length && r(e.length - 1), !0;
			let a = ur(i) ? i.nativeEvent.isComposing : i.isComposing;
			return i.key === "Enter" && !a ? (i.preventDefault(), i.stopPropagation(), e.length && t?.(e[n]), !0) : !1;
		}
	};
}
function ur(e) {
	return e.nativeEvent !== void 0;
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useSuggestionMenuKeyboardNavigation.ts
function dr(t, n, r, i, a) {
	let o = e(), { selectedIndex: s, setSelectedIndex: c, handler: l } = lr(r, i);
	return w(() => {
		let e = a || o;
		return e?.addEventListener("keydown", l, !0), () => {
			e?.removeEventListener("keydown", l, !0);
		};
	}, [
		o,
		r,
		s,
		i,
		a,
		l
	]), w(() => {
		c(0);
	}, [n, c]), { selectedIndex: r.length === 0 ? void 0 : s };
}
//#endregion
//#region src/components/SuggestionMenu/SuggestionMenuWrapper.tsx
function fr(e) {
	let t = i().setContentEditableProps, n = c(), { getItems: r, suggestionMenuComponent: a, query: o, clearQuery: s, closeMenu: l, onItemClick: u } = e, d = S((e) => {
		l(), s(), u?.(e);
	}, [
		u,
		l,
		s
	]), { items: f, usedQuery: p, loadingState: m } = ir(o, r);
	rr(f, p, l);
	let { selectedIndex: h } = dr(n, o, f, d);
	return w(() => (t((e) => ({
		...e,
		"aria-expanded": !0,
		"aria-controls": "bn-suggestion-menu"
	})), () => {
		t((e) => ({
			...e,
			"aria-expanded": !1,
			"aria-controls": void 0
		}));
	}), [t]), w(() => (t((e) => ({
		...e,
		"aria-activedescendant": h ? "bn-suggestion-menu-item-" + h : void 0
	})), () => {
		t((e) => ({
			...e,
			"aria-activedescendant": void 0
		}));
	}), [t, h]), /* @__PURE__ */ W(a, {
		items: f,
		onItemClick: d,
		loadingState: m,
		selectedIndex: h
	});
}
//#endregion
//#region src/components/SuggestionMenu/getDefaultReactSlashMenuItems.tsx
var pr = {
	heading: K,
	heading_2: q,
	heading_3: J,
	heading_4: _t,
	heading_5: vt,
	heading_6: yt,
	toggle_heading: K,
	toggle_heading_2: q,
	toggle_heading_3: J,
	quote: Ft,
	toggle_list: Pt,
	numbered_list: At,
	bullet_list: jt,
	check_list: kt,
	paragraph: zt,
	table: Rt,
	image: bt,
	video: ht,
	audio: Ht,
	file: mt,
	emoji: ft,
	code_block: ct,
	divider: Lt
};
function mr(e) {
	return me(e).map((e) => {
		let t = pr[e.key];
		return {
			...e,
			icon: /* @__PURE__ */ W(t, { size: 18 })
		};
	});
}
//#endregion
//#region src/components/SuggestionMenu/SuggestionMenuController.tsx
function hr(t) {
	let n = c(), i = e(), { triggerCharacter: a, suggestionMenuComponent: o, shouldOpen: s, minQueryLength: l, onItemClick: d, getItems: f } = t, m = E(() => d || ((e) => {
		e.onItemClick(n);
	}), [n, d]), h = E(() => f || (async (e) => fe(mr(n), e)), [n, f]), g = r(N);
	w(() => {
		g.addSuggestionMenu({
			triggerCharacter: a,
			shouldOpen: s
		});
	}, [
		g,
		a,
		s
	]);
	let _ = u(N), v = u(N, { selector: (e) => ({
		element: i?.firstChild || void 0,
		getBoundingClientRect: () => e?.referencePos || new DOMRect()
	}) }), y = E(() => ({
		...t.floatingUIOptions,
		useFloatingOptions: {
			open: _?.show && _?.triggerCharacter === a,
			onOpenChange: (e) => {
				e || g.closeMenu();
			},
			placement: "bottom-start",
			middleware: [
				F(10),
				he({
					allowedPlacements: ["bottom-start", "top-start"],
					padding: 10
				}),
				ye(),
				I({
					apply({ elements: e, availableHeight: t }) {
						e.floating.style.maxHeight = `${Math.max(0, t)}px`;
					},
					padding: 10
				})
			],
			...t.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...t.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			onMouseDownCapture: (e) => e.preventDefault(),
			style: { zIndex: 80 },
			...t.floatingUIOptions?.elementProps
		}
	}), [
		t.floatingUIOptions,
		_?.show,
		_?.triggerCharacter,
		g,
		a
	]);
	return !_ || !_.ignoreQueryLength && l && (_.query.startsWith(" ") || _.query.length < l) ? null : /* @__PURE__ */ W(p, {
		reference: v,
		...y,
		children: a && /* @__PURE__ */ W(fr, {
			query: _.query,
			closeMenu: g.closeMenu,
			clearQuery: g.clearQuery,
			getItems: h,
			suggestionMenuComponent: o || cr,
			onItemClick: m
		})
	});
}
//#endregion
//#region src/components/TableHandles/ExtendButton/ExtendButton.tsx
var gr = (e, t = .3) => {
	let n = Math.floor(e) + t, r = Math.ceil(e) - t;
	return e >= n && e <= r ? Math.round(e) : e < n ? Math.floor(e) : Math.ceil(e);
}, _r = (e) => {
	let t = s(), n = c(), i = r(P), a = u(P, { selector: (e) => e?.block }), o = D(!1), [l, d] = O(), f = S((t) => {
		i.freezeHandles(), e.hideOtherElements(!0), a && (d({
			originalContent: a.content,
			originalCroppedContent: { rows: i.cropEmptyRowsOrColumns(a, e.orientation === "addOrRemoveColumns" ? "columns" : "rows") },
			startPos: e.orientation === "addOrRemoveColumns" ? t.clientX : t.clientY
		}), o.current = !1, t.preventDefault());
	}, [
		a,
		e,
		i
	]), p = S(() => {
		!a || o.current || n.updateBlock(a, {
			type: "table",
			content: {
				...a.content,
				rows: e.orientation === "addOrRemoveColumns" ? i.addRowsOrColumns(a, "columns", 1) : i.addRowsOrColumns(a, "rows", 1)
			}
		});
	}, [
		a,
		n,
		e.orientation,
		i
	]);
	return w(() => {
		let t = (t) => {
			if (!a) return;
			if (!l) throw Error("editingState is undefined");
			o.current = !0;
			let r = (e.orientation === "addOrRemoveColumns" ? t.clientX : t.clientY) - l.startPos, s = e.orientation === "addOrRemoveColumns" ? l.originalCroppedContent.rows[0]?.cells.length ?? 0 : l.originalCroppedContent.rows.length, c = e.orientation === "addOrRemoveColumns" ? l.originalContent.rows[0]?.cells.length ?? 0 : l.originalContent.rows.length, u = e.orientation === "addOrRemoveColumns" ? a.content.rows[0].cells.length : a.content.rows.length, d = c + gr(r / (e.orientation === "addOrRemoveColumns" ? Ce : Se), .3);
			d >= s && d > 0 && d !== u && (n.updateBlock(a, {
				type: "table",
				content: {
					...a.content,
					rows: e.orientation === "addOrRemoveColumns" ? i.addRowsOrColumns({
						type: "table",
						content: l.originalCroppedContent
					}, "columns", d - s) : i.addRowsOrColumns({
						type: "table",
						content: l.originalCroppedContent
					}, "rows", d - s)
				}
			}), a.content && n.setTextCursorPosition(a));
		};
		return l && window.addEventListener("mousemove", t), () => {
			window.removeEventListener("mousemove", t);
		};
	}, [
		a,
		l,
		n,
		e.orientation,
		i
	]), w(() => {
		let t = () => {
			e.hideOtherElements(!1), i.unfreezeHandles(), d(void 0);
		};
		return l && window.addEventListener("mouseup", t), () => {
			window.removeEventListener("mouseup", t);
		};
	}, [
		l,
		e,
		i
	]), n.isEditable ? /* @__PURE__ */ W(t.TableHandle.ExtendButton, {
		className: H("bn-extend-button", e.orientation === "addOrRemoveColumns" ? "bn-extend-button-add-remove-columns" : "bn-extend-button-add-remove-rows", l === null ? "" : "bn-extend-button-editing"),
		onClick: p,
		onMouseDown: f,
		children: e.children || /* @__PURE__ */ W(tt, {
			size: 18,
			"data-test": "extendButton"
		})
	}) : null;
}, vr = (e) => {
	let t = s(), n = f(), r = c(), { block: i, colIndex: a, rowIndex: o } = u(P, { selector: (e) => ({
		block: e?.block,
		colIndex: e?.colIndex,
		rowIndex: e?.rowIndex
	}) }), l = (e, t) => {
		if (i === void 0 || a === void 0 || o === void 0) return;
		let n = i.content.rows.map((e) => ({
			...e,
			cells: e.cells.map((e) => V(e))
		}));
		t === "text" ? n[o].cells[a].props.textColor = e : n[o].cells[a].props.backgroundColor = e, r.updateBlock(i, {
			type: "table",
			content: {
				...i.content,
				rows: n
			}
		}), r.setTextCursorPosition(i);
	};
	if (i === void 0 || a === void 0 || o === void 0) return null;
	let d = i.content.rows[o]?.cells?.[a];
	return !d || r.settings.tables.cellTextColor === !1 && r.settings.tables.cellBackgroundColor === !1 ? null : /* @__PURE__ */ G(t.Generic.Menu.Root, {
		position: "right",
		sub: !0,
		children: [/* @__PURE__ */ W(t.Generic.Menu.Trigger, {
			sub: !0,
			children: /* @__PURE__ */ W(t.Generic.Menu.Item, {
				className: "bn-menu-item",
				subTrigger: !0,
				children: e.children || n.drag_handle.colors_menuitem
			})
		}), /* @__PURE__ */ W(t.Generic.Menu.Dropdown, {
			sub: !0,
			className: "bn-menu-dropdown bn-color-picker-dropdown",
			children: /* @__PURE__ */ W(fn, {
				iconSize: 18,
				text: r.settings.tables.cellTextColor ? {
					color: B(d) ? d.props.textColor : "default",
					setColor: (e) => l(e, "text")
				} : void 0,
				background: r.settings.tables.cellBackgroundColor ? {
					color: B(d) ? d.props.backgroundColor : "default",
					setColor: (e) => l(e, "background")
				} : void 0
			})
		})]
	});
}, yr = () => {
	let e = s(), t = f(), n = c(), i = r(P), { block: a, colIndex: o, rowIndex: l } = u(P, { selector: (e) => ({
		block: e?.block,
		colIndex: e?.colIndex,
		rowIndex: e?.rowIndex
	}) });
	if (a === void 0 || o === void 0 || l === void 0) return null;
	let d = a.content.rows[l]?.cells?.[o];
	return !d || !B(d) || Ge(d) === 1 && Ve(d) === 1 || !n.settings.tables.splitCells ? null : /* @__PURE__ */ W(e.Generic.Menu.Item, {
		onClick: () => {
			i.splitCell({
				row: l,
				col: o
			});
		},
		children: t.table_handle.split_cell_menuitem
	});
}, br = (e) => /* @__PURE__ */ W(s().Generic.Menu.Dropdown, {
	className: "bn-menu-dropdown bn-table-handle-menu",
	children: e.children || /* @__PURE__ */ G(U, { children: [/* @__PURE__ */ W(yr, {}), /* @__PURE__ */ W(vr, {})] })
}), xr = (e) => {
	let t = s(), n = c(), i = r(P), a = e.tableCellMenu || br;
	return !n.settings.tables.splitCells && !n.settings.tables.cellBackgroundColor && !n.settings.tables.cellTextColor ? null : /* @__PURE__ */ G(t.Generic.Menu.Root, {
		onOpenChange: (t) => {
			t ? (i.freezeHandles(), e.hideOtherElements(!0)) : (i.unfreezeHandles(), e.hideOtherElements(!1), n.focus());
		},
		position: "right",
		children: [/* @__PURE__ */ W(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ W(t.Generic.Menu.Button, {
			className: "bn-table-cell-handle",
			children: e.children || /* @__PURE__ */ W(Wt, {
				size: 12,
				"data-test": "tableCellHandle"
			})
		}) }), /* @__PURE__ */ W(a, {})]
	});
}, Sr = (e) => {
	let t = s(), n = f(), i = r(P), a = u(P, { selector: (t) => e.orientation === "column" ? t?.colIndex : t?.rowIndex });
	return i === void 0 || a === void 0 ? null : /* @__PURE__ */ W(t.Generic.Menu.Item, {
		onClick: () => {
			i.addRowOrColumn(a, e.orientation === "row" ? {
				orientation: "row",
				side: e.side
			} : {
				orientation: "column",
				side: e.side
			});
		},
		children: n.table_handle[`add_${e.side}_menuitem`]
	});
}, Cr = (e) => {
	let t = s(), n = f(), i = r(P), a = u(P, { selector: (t) => e.orientation === "column" ? t?.colIndex : t?.rowIndex });
	return i === void 0 || a === void 0 ? null : /* @__PURE__ */ W(t.Generic.Menu.Item, {
		onClick: () => i.removeRowOrColumn(a, e.orientation),
		children: e.orientation === "row" ? n.table_handle.delete_row_menuitem : n.table_handle.delete_column_menuitem
	});
}, wr = (e) => {
	let t = s(), n = f(), i = c(), a = r(P), { block: o, index: l } = u(P, { selector: (t) => ({
		block: t?.block,
		index: e.orientation === "column" ? t?.colIndex : t?.rowIndex
	}) }), d = E(() => a === void 0 || o === void 0 || l === void 0 ? [] : e.orientation === "row" ? a.getCellsAtRowHandle(o, l) : a.getCellsAtColumnHandle(o, l), [
		o,
		l,
		e.orientation,
		a
	]), p = (e, t) => {
		if (o === void 0) return;
		let n = o.content.rows.map((e) => ({
			...e,
			cells: e.cells.map((e) => V(e))
		}));
		d.forEach(({ row: r, col: i }) => {
			t === "text" ? n[r].cells[i].props.textColor = e : n[r].cells[i].props.backgroundColor = e;
		}), i.updateBlock(o, {
			type: "table",
			content: {
				...o.content,
				rows: n
			}
		}), i.setTextCursorPosition(o);
	};
	if (!d || !d[0] || !a || i.settings.tables.cellTextColor === !1 && i.settings.tables.cellBackgroundColor === !1) return null;
	let m = V(d[0].cell);
	return /* @__PURE__ */ G(t.Generic.Menu.Root, {
		position: "right",
		sub: !0,
		children: [/* @__PURE__ */ W(t.Generic.Menu.Trigger, {
			sub: !0,
			children: /* @__PURE__ */ W(t.Generic.Menu.Item, {
				className: "bn-menu-item",
				subTrigger: !0,
				children: e.children || n.drag_handle.colors_menuitem
			})
		}), /* @__PURE__ */ W(t.Generic.Menu.Dropdown, {
			sub: !0,
			className: "bn-menu-dropdown bn-color-picker-dropdown",
			children: /* @__PURE__ */ W(fn, {
				iconSize: 18,
				text: i.settings.tables.cellTextColor ? {
					color: d.every(({ cell: e }) => B(e) && e.props.textColor === m.props.textColor) ? m.props.textColor : "default",
					setColor: (e) => {
						p(e, "text");
					}
				} : void 0,
				background: i.settings.tables.cellBackgroundColor ? {
					color: d.every(({ cell: e }) => B(e) && e.props.backgroundColor === m.props.backgroundColor) ? m.props.backgroundColor : "default",
					setColor: (e) => p(e, "background")
				} : void 0
			})
		})]
	});
}, Tr = (e) => {
	let t = s(), n = f(), i = c(), a = r(P), { block: o, index: l } = u(P, { selector: (t) => ({
		block: t?.block,
		index: e.orientation === "column" ? t?.colIndex : t?.rowIndex
	}) });
	if (a === void 0 || o === void 0 || l !== 0 || e.orientation !== "row" || !i.settings.tables.headers) return null;
	let d = !!o.content.headerRows;
	return /* @__PURE__ */ W(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: d,
		onClick: () => {
			i.updateBlock(o, {
				...o,
				content: {
					...o.content,
					headerRows: d ? void 0 : 1
				}
			});
		},
		children: n.drag_handle.header_row_menuitem
	});
}, Er = (e) => {
	let t = s(), n = f(), i = c(), a = r(P), o = u(P, { selector: (e) => e?.block }), l = u(P, { selector: (t) => e.orientation === "column" ? t?.colIndex : t?.rowIndex });
	if (!a || l !== 0 || !o || e.orientation !== "column" || !i.settings.tables.headers) return null;
	let d = !!o.content.headerCols;
	return /* @__PURE__ */ W(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: d,
		onClick: () => {
			i.updateBlock(o, {
				...o,
				content: {
					...o.content,
					headerCols: d ? void 0 : 1
				}
			});
		},
		children: n.drag_handle.header_column_menuitem
	});
}, Dr = (e) => /* @__PURE__ */ W(s().Generic.Menu.Dropdown, {
	className: "bn-table-handle-menu",
	children: e.children || /* @__PURE__ */ G(U, { children: [
		/* @__PURE__ */ W(Cr, { orientation: e.orientation }),
		/* @__PURE__ */ W(Sr, {
			orientation: e.orientation,
			side: e.orientation === "row" ? "above" : "left"
		}),
		/* @__PURE__ */ W(Sr, {
			orientation: e.orientation,
			side: e.orientation === "row" ? "below" : "right"
		}),
		/* @__PURE__ */ W(Tr, { orientation: e.orientation }),
		/* @__PURE__ */ W(Er, { orientation: e.orientation }),
		/* @__PURE__ */ W(wr, { orientation: e.orientation })
	] })
}), Or = (e) => {
	let t = c(), n = s(), [i, a] = O(!1), o = e.tableHandleMenu || Dr, l = r(P), d = u(P), f = E(() => !l || !d || !d.block || d.block.type !== "table" ? !1 : e.orientation === "column" ? l.getCellsAtColumnHandle(d.block, d.colIndex).every(({ cell: e }) => Ve(e) === 1) : l.getCellsAtRowHandle(d.block, d.rowIndex).every(({ cell: e }) => Ge(e) === 1), [
		e.orientation,
		d,
		l
	]);
	return d ? /* @__PURE__ */ G(n.Generic.Menu.Root, {
		onOpenChange: (n) => {
			n ? (l.freezeHandles(), e.hideOtherElements(!0)) : (l.unfreezeHandles(), e.hideOtherElements(!1), t.focus());
		},
		position: "right",
		children: [/* @__PURE__ */ W(n.Generic.Menu.Trigger, { children: /* @__PURE__ */ W(n.TableHandle.Root, {
			className: H("bn-table-handle", i ? "bn-table-handle-dragging" : "", f ? "" : "bn-table-handle-not-draggable"),
			draggable: f,
			onDragStart: (t) => {
				a(!0), e.hideOtherElements(!0), e.orientation === "column" ? l.colDragStart(t) : l.rowDragStart(t);
			},
			onDragEnd: () => {
				l.dragEnd(), e.hideOtherElements(!1), a(!1);
			},
			style: e.orientation === "column" ? { transform: "rotate(0.25turn)" } : void 0,
			children: e.children || /* @__PURE__ */ W(Gt, {
				size: 24,
				"data-test": "tableHandle"
			})
		}) }), /* @__PURE__ */ W(o, { orientation: e.orientation })]
	}) : null;
}, kr = (e) => {
	let t = c(), [n, r] = O(), i = u(P), a = E(() => {
		let e = {};
		if (i === void 0) return {};
		let n = Ue(i.block.id, t.prosemirrorState.doc);
		if (!n) return {};
		let r = n.posBeforeNode + 1, a = t.prosemirrorView.domAtPos(r + 1).node;
		if (!(a instanceof Element)) return {};
		if (e.tableReference = { element: a }, i.rowIndex === void 0 || i.colIndex === void 0) return e;
		let o = t.prosemirrorState.doc.resolve(r + 1).posAtIndex(i.rowIndex), s = t.prosemirrorState.doc.resolve(o + 1).posAtIndex(i.colIndex), c = t.prosemirrorView.domAtPos(s + 1).node;
		return c instanceof Element ? (e.cellReference = { element: c }, e.rowReference = {
			element: a,
			getBoundingClientRect: () => {
				let e = a.getBoundingClientRect(), t = c.getBoundingClientRect();
				return new DOMRect(e.x, i.draggingState && i.draggingState.draggedCellOrientation === "row" ? i.draggingState.mousePos - t.height / 2 : t.y, e.width, t.height);
			}
		}, e.columnReference = {
			element: a,
			getBoundingClientRect: () => {
				let e = a.getBoundingClientRect(), t = c.getBoundingClientRect();
				return new DOMRect(i.draggingState && i.draggingState.draggedCellOrientation === "col" ? i.draggingState.mousePos - t.width / 2 : t.x, e.y, t.width, e.height);
			}
		}, e) : {};
	}, [t, i]), o = S((e, n, r) => {
		let i = !1;
		return ge(e, n, () => {
			if (!i) {
				i = !0;
				return;
			}
			t.getExtension(P)?.hideHandlesIfNotFrozen();
		}, {
			ancestorScroll: !0,
			ancestorResize: !1,
			elementResize: !1,
			layoutShift: !1
		});
	}, [t]), s = E(() => i === void 0 ? void 0 : {
		rowTableHandle: {
			useFloatingOptions: {
				open: i.show && i.rowIndex !== void 0 && (!n || n === "rowTableHandle"),
				placement: "left",
				middleware: [F(-10)],
				whileElementsMounted: o
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		columnTableHandle: {
			useFloatingOptions: {
				open: i.show && i.colIndex !== void 0 && (!n || n === "columnTableHandle"),
				placement: "top",
				middleware: [F(-12)],
				whileElementsMounted: o
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		tableCellHandle: {
			useFloatingOptions: {
				open: i.show && i.rowIndex !== void 0 && i.colIndex !== void 0 && (!n || n === "tableCellHandle"),
				placement: "top-end",
				middleware: [F({
					mainAxis: -15,
					crossAxis: -1
				})],
				whileElementsMounted: o
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		extendRowsButton: {
			useFloatingOptions: {
				open: i.show && i.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton"),
				placement: "bottom",
				whileElementsMounted: o,
				middleware: [I({ apply({ rects: e, elements: t }) {
					Object.assign(t.floating.style, { width: `${e.reference.width}px` });
				} })]
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		extendColumnsButton: {
			useFloatingOptions: {
				open: i.show && i.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton"),
				placement: "right",
				whileElementsMounted: o,
				middleware: [I({ apply({ rects: e, elements: t }) {
					Object.assign(t.floating.style, { height: `${e.reference.height}px` });
				} })]
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		}
	}, [
		n,
		i,
		o
	]);
	if (!i) return null;
	let l = e.tableHandle || Or, d = e.extendButton || _r, f = e.tableCellHandle || xr;
	return /* @__PURE__ */ G(U, { children: [
		/* @__PURE__ */ W(p, {
			reference: a?.rowReference,
			...s?.rowTableHandle,
			children: i.show && i.rowIndex !== void 0 && (!n || n === "rowTableHandle") && /* @__PURE__ */ W(l, {
				orientation: "row",
				hideOtherElements: (e) => r(e ? "rowTableHandle" : void 0)
			})
		}),
		/* @__PURE__ */ W(p, {
			reference: a?.columnReference,
			...s?.columnTableHandle,
			children: i.show && i.colIndex !== void 0 && (!n || n === "columnTableHandle") && /* @__PURE__ */ W(l, {
				orientation: "column",
				hideOtherElements: (e) => r(e ? "columnTableHandle" : void 0)
			})
		}),
		/* @__PURE__ */ W(p, {
			reference: a?.cellReference,
			...s?.tableCellHandle,
			children: i.show && i.rowIndex !== void 0 && i.colIndex !== void 0 && (!n || n === "tableCellHandle") && /* @__PURE__ */ W(f, { hideOtherElements: (e) => r(e ? "tableCellHandle" : void 0) })
		}),
		/* @__PURE__ */ W(p, {
			reference: a?.tableReference,
			...s?.extendRowsButton,
			children: i.show && i.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton") && /* @__PURE__ */ W(d, {
				orientation: "addOrRemoveRows",
				hideOtherElements: (e) => r(e ? "extendRowsButton" : void 0)
			})
		}),
		/* @__PURE__ */ W(p, {
			reference: a?.tableReference,
			...s?.extendColumnsButton,
			children: i.show && i.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton") && /* @__PURE__ */ W(d, {
				orientation: "addOrRemoveColumns",
				hideOtherElements: (e) => r(e ? "extendColumnsButton" : void 0)
			})
		})
	] });
}, Ar = ae(() => import("./FloatingComposerController-KlxX35Kg.js").then((e) => e.n)), jr = ae(() => import("./FloatingThreadController-DXD0P6RJ.js").then((e) => e.n));
function Mr(e) {
	let t = c();
	if (!t) throw Error("BlockNoteDefaultUI must be used within a BlockNoteContext.Provider");
	return /* @__PURE__ */ G(U, { children: [
		t.getExtension(j) && e.formattingToolbar !== !1 && /* @__PURE__ */ W(Bn, {}),
		t.getExtension(le) && e.linkToolbar !== !1 && /* @__PURE__ */ W(Gn, {}),
		t.getExtension(N) && e.slashMenu !== !1 && /* @__PURE__ */ W(hr, {
			triggerCharacter: "/",
			shouldOpen: (e) => !e.selection.$from.parent.type.isInGroup("tableContent")
		}),
		t.getExtension(N) && e.emojiPicker !== !1 && /* @__PURE__ */ W(sr, {
			triggerCharacter: ":",
			columns: 10,
			minQueryLength: 2
		}),
		t.getExtension(M) && e.sideMenu !== !1 && /* @__PURE__ */ W(er, {}),
		t.getExtension(A) && e.filePanel !== !1 && /* @__PURE__ */ W(sn, {}),
		t.getExtension(P) && e.tableHandles !== !1 && /* @__PURE__ */ W(kr, {}),
		t.getExtension(k) && e.comments !== !1 && /* @__PURE__ */ G(ne, { children: [/* @__PURE__ */ W(Ar, {}), /* @__PURE__ */ W(jr, {})] })
	] });
}
//#endregion
//#region src/hooks/useEditorChange.ts
function Nr(e, t) {
	let n = i();
	t ||= n?.editor, w(() => {
		if (!t) throw Error("'editor' is required, either from BlockNoteContext or as a function argument");
		return t.onChange(e);
	}, [e, t]);
}
//#endregion
//#region src/hooks/useEditorSelectionChange.ts
function Pr(e, t, n) {
	let r = i();
	t ||= r?.editor, w(() => {
		if (!t) throw Error("'editor' is required, either from BlockNoteContext or as a function argument");
		return t.onSelectionChange(e, n);
	}, [
		e,
		t,
		n
	]);
}
//#endregion
//#region src/hooks/usePrefersColorScheme.ts
var Fr = () => {
	let e = E(() => window.matchMedia?.("(prefers-color-scheme: dark)"), []), t = E(() => window.matchMedia?.("(prefers-color-scheme: light)"), []), n = e?.matches, r = t?.matches, [i, a] = O(n ? "dark" : r ? "light" : "no-preference");
	return w(() => {
		a(n ? "dark" : r ? "light" : "no-preference");
	}, [n, r]), w(() => {
		if (typeof e?.addEventListener == "function") {
			let n = ({ matches: e }) => e && a("dark"), r = ({ matches: e }) => e && a("light");
			return e?.addEventListener("change", n), t?.addEventListener("change", r), () => {
				e?.removeEventListener("change", n), t?.removeEventListener("change", r);
			};
		} else {
			let n = () => a(e.matches ? "dark" : t.matches ? "light" : "no-preference");
			return e?.addEventListener("change", n), t?.addEventListener("change", n), () => {
				e?.removeEventListener("change", n), t?.removeEventListener("change", n);
			};
		}
	}, [e, t]), window.matchMedia, i;
}, Ir = re(void 0);
function Lr() {
	return C(Ir);
}
//#endregion
//#region src/editor/EditorContent.tsx
function Rr() {
	let e = /* @__PURE__ */ new Set(), t = {};
	return {
		subscribe(t) {
			return e.add(t), () => {
				e.delete(t);
			};
		},
		getSnapshot() {
			return t;
		},
		getServerSnapshot() {
			return t;
		},
		setRenderer(n, r) {
			t = {
				...t,
				[n]: Kt(r.reactElement, r.element, n)
			}, e.forEach((e) => e());
		},
		removeRenderer(n) {
			let r = { ...t };
			delete r[n], t = r, e.forEach((e) => e());
		}
	};
}
var zr = ({ contentComponent: e }) => {
	let t = se(e.subscribe, e.getSnapshot, e.getServerSnapshot);
	return /* @__PURE__ */ W(U, { children: Object.values(t) });
}, Br = ie((e, t) => {
	let [n, r] = O();
	return T(t, () => (e, t) => {
		qt(() => {
			r({
				node: e,
				container: t
			});
		}), r(void 0);
	}, []), /* @__PURE__ */ W(U, { children: n && Kt(n.node, n.container) });
}), Vr = () => {};
function Hr(e, t) {
	let { editor: n, className: r, theme: o, children: c, editable: l, onSelectionChange: u, onChange: d, formattingToolbar: f, linkToolbar: p, slashMenu: m, emojiPicker: h, sideMenu: g, filePanel: _, tableHandles: v, comments: y, autoFocus: b, renderEditor: ee = !0, ...te } = e, [x, ne] = O(), re = i(), ie = Fr(), ae = re?.colorSchemePreference || ie, C = o || (ae === "dark" ? "dark" : "light"), T = s(), oe = E(() => ({
		formattingToolbar: T ? f : !1,
		linkToolbar: T ? p : !1,
		sideMenu: T ? g : !1,
		slashMenu: T ? m : !1,
		filePanel: T ? _ : !1,
		tableHandles: T ? v : !1,
		emojiPicker: T ? h : !1,
		comments: T ? y : !1
	}), [
		y,
		T,
		h,
		_,
		f,
		p,
		g,
		m,
		v
	]);
	Nr(d || Vr, n), Pr(u || Vr, n);
	let D = S((e) => {
		n.elementRenderer = e;
	}, [n]);
	w(() => {
		if (!n.portalElement) throw Error("Portal element not found");
		n.portalElement.className = H("bn-root", C, r || ""), n.portalElement.setAttribute("data-color-scheme", C);
	}, [
		n,
		C,
		r
	]);
	let se = E(() => ({
		...re,
		editor: n,
		setContentEditableProps: ne,
		colorSchemePreference: C
	}), [
		re,
		n,
		C
	]), k = E(() => ({
		editorProps: {
			autoFocus: b,
			contentEditableProps: x,
			editable: l
		},
		defaultUIProps: oe
	}), [
		b,
		x,
		l,
		oe
	]);
	return /* @__PURE__ */ W(a.Provider, {
		value: se,
		children: /* @__PURE__ */ G(Ir.Provider, {
			value: k,
			children: [/* @__PURE__ */ W(Br, { ref: D }), /* @__PURE__ */ W(Ur, {
				className: r,
				renderEditor: ee,
				editorColorScheme: C,
				ref: t,
				...te,
				children: c
			})]
		})
	});
}
var Ur = x.forwardRef(({ className: e, renderEditor: t, editorColorScheme: n, children: r, ...i }, a) => /* @__PURE__ */ W("div", {
	className: H("bn-root", "bn-container", n, e),
	"data-color-scheme": n,
	...i,
	ref: a,
	children: t ? /* @__PURE__ */ W(Gr, { children: r }) : r
})), Wr = x.forwardRef(Hr), Gr = (e) => {
	let t = Lr(), n = c(), r = E(() => Rr(), []), i = S((e) => {
		n.isEditable = t.editorProps.editable !== !1, n._tiptapEditor.contentComponent = r, e ? n.mount(e) : n.unmount();
	}, [
		t.editorProps.editable,
		n,
		r
	]);
	return /* @__PURE__ */ G(U, { children: [
		/* @__PURE__ */ W(zr, { contentComponent: r }),
		/* @__PURE__ */ W(Kr, {
			...t.editorProps,
			...e,
			mount: i
		}),
		/* @__PURE__ */ W(Mr, { ...t.defaultUIProps }),
		e.children
	] });
}, Kr = (e) => {
	let { autoFocus: t, mount: n, contentEditableProps: r } = e;
	return /* @__PURE__ */ W("div", {
		"aria-autocomplete": "list",
		"aria-haspopup": "listbox",
		"data-bn-autofocus": t,
		ref: n,
		...r
	});
};
//#endregion
//#region src/schema/@util/ReactRenderUtil.ts
function X(e, t) {
	let n, r = document.createElement("div"), i;
	if (t?.elementRenderer) t.elementRenderer(e((e) => n = e || void 0), r);
	else {
		if (!t?.headless) throw Error("elementRenderer not available, expected headless editor");
		i = en(r), qt(() => {
			i.render(e((e) => n = e || void 0));
		});
	}
	if (!r.childElementCount) return console.warn("ReactInlineContentSpec: renderHTML() failed"), { dom: document.createElement("span") };
	n?.setAttribute("data-tmp-find", "true");
	let a = r.cloneNode(!0), o = a.firstElementChild, s = a.querySelector("[data-tmp-find]");
	return s?.removeAttribute("data-tmp-find"), i?.unmount(), {
		dom: o,
		contentDOM: s || void 0
	};
}
//#endregion
//#region src/schema/ReactBlockSpec.tsx
function Z(e) {
	return /* @__PURE__ */ W(Yt, {
		onDragOver: (e) => e.preventDefault(),
		...Object.fromEntries(Object.entries(e.domAttributes || {}).filter(([e]) => e !== "class")),
		className: H("bn-block-content", e.domAttributes?.class || ""),
		"data-content-type": e.blockType,
		...Object.fromEntries(Object.entries(e.blockProps).filter(([t, n]) => n !== e.propSchema[t].default).map(([e, t]) => [ke(e), t])),
		"data-file-block": e.isFileBlock === !0 || void 0,
		children: e.children
	});
}
function Q(e, t, n) {
	return (r = {}) => {
		let i = typeof e == "function" ? e(r) : e, a = typeof t == "function" ? t(r) : t, o = n ? typeof n == "function" ? n(r) : n : void 0;
		return {
			config: i,
			implementation: {
				...a,
				toExternalHTML(e, t, n) {
					let r = a.toExternalHTML || a.render;
					return X((o) => /* @__PURE__ */ W(Z, {
						blockType: e.type,
						blockProps: e.props,
						propSchema: i.propSchema,
						domAttributes: this.blockContentDOMAttributes,
						isFileBlock: a.meta?.fileBlockAccept !== void 0,
						children: /* @__PURE__ */ W(r, {
							block: e,
							editor: t,
							contentRef: (e) => {
								o(e), e && (e.className = H("bn-inline-content", e.className));
							},
							context: n
						})
					}), t);
				},
				render(e, t) {
					if (this.renderType === "nodeView") return Qt((e) => {
						let n = Be(e.getPos, t, e.editor, i.type), r = $t().nodeViewContentRef;
						if (!r) throw Error("nodeViewContentRef is not set");
						let o = a.render;
						return /* @__PURE__ */ W(Z, {
							blockType: n.type,
							blockProps: n.props,
							propSchema: i.propSchema,
							isFileBlock: !!a.meta?.fileBlockAccept,
							domAttributes: this.blockContentDOMAttributes,
							children: /* @__PURE__ */ W(o, {
								block: n,
								editor: t,
								contentRef: (e) => {
									r(e), e && (e.className = H("bn-inline-content", e.className), e.dataset.nodeViewContent = "");
								}
							})
						});
					}, { className: "bn-react-node-view-renderer" })(this.props);
					{
						let n = a.render;
						return X((r) => /* @__PURE__ */ W(Z, {
							blockType: e.type,
							blockProps: e.props,
							propSchema: i.propSchema,
							domAttributes: this.blockContentDOMAttributes,
							children: /* @__PURE__ */ W(n, {
								block: e,
								editor: t,
								contentRef: (e) => {
									r(e), e && (e.className = H("bn-inline-content", e.className));
								}
							})
						}), t);
					}
				}
			},
			extensions: o
		};
	};
}
//#endregion
//#region src/blocks/File/useResolveUrl.tsx
function qr(e) {
	let t = c(), [n, r] = O("loading"), [i, a] = O();
	if (w(() => {
		let n = !0;
		return (async () => {
			let i = "";
			r("loading");
			try {
				i = t.resolveFileUrl ? await t.resolveFileUrl(e) : e;
			} catch {
				r("error");
				return;
			}
			n && (r("loaded"), a(i));
		})(), () => {
			n = !1;
		};
	}, [t, e]), n !== "loaded") return { loadingState: n };
	if (!i) throw Error("Finished fetching file but did not get download URL.");
	return {
		loadingState: n,
		downloadUrl: i
	};
}
//#endregion
//#region src/blocks/File/helpers/toExternalHTML/FigureWithCaption.tsx
var Jr = (e) => /* @__PURE__ */ G("figure", { children: [e.children, /* @__PURE__ */ W("figcaption", { children: e.caption })] });
//#endregion
//#region src/hooks/useOnUploadEnd.ts
function Yr(e) {
	let t = c();
	w(() => t.onUploadEnd(e), [e, t]);
}
//#endregion
//#region src/hooks/useOnUploadStart.ts
function Xr(e) {
	let t = c();
	w(() => t.onUploadStart(e), [e, t]);
}
//#endregion
//#region src/hooks/useUploadLoading.ts
function Zr(e) {
	let [t, n] = O(!1);
	return Xr((t) => {
		t === e && n(!0);
	}), Yr((t) => {
		t === e && n(!1);
	}), t;
}
//#endregion
//#region src/blocks/File/helpers/render/AddFileButton.tsx
var Qr = (e) => {
	let t = c(), n = f(), i = r(A);
	return /* @__PURE__ */ G("div", {
		className: "bn-add-file-button",
		onMouseDown: S((e) => {
			e.preventDefault();
		}, []),
		onClick: S(() => {
			t.isEditable && e.editor.transact(() => i.showMenu(e.block.id));
		}, [
			t.isEditable,
			i,
			e.block.id,
			e.editor
		]),
		children: [/* @__PURE__ */ W("div", {
			className: "bn-add-file-button-icon",
			children: e.buttonIcon || /* @__PURE__ */ W(mt, { size: 24 })
		}), /* @__PURE__ */ W("div", {
			className: "bn-add-file-button-text",
			children: e.block.type in n.file_blocks.add_button_text ? n.file_blocks.add_button_text[e.block.type] : n.file_blocks.add_button_text.file
		})]
	});
}, $r = (e) => /* @__PURE__ */ G("div", {
	className: "bn-file-name-with-icon",
	contentEditable: !1,
	draggable: !1,
	children: [/* @__PURE__ */ W("div", {
		className: "bn-file-icon",
		children: /* @__PURE__ */ W(mt, { size: 24 })
	}), /* @__PURE__ */ W("p", {
		className: "bn-file-name",
		children: e.block.props.name
	})]
}), ei = (e) => {
	let t = Zr(e.block.id);
	return /* @__PURE__ */ W(e.block.props.url !== "" && e.block.props.caption && !t ? "figure" : "div", {
		className: "bn-file-block-content-wrapper",
		onMouseEnter: e.onMouseEnter,
		onMouseLeave: e.onMouseLeave,
		style: e.style,
		children: t ? /* @__PURE__ */ W("div", {
			className: "bn-file-loading-preview",
			children: "Loading..."
		}) : e.block.props.url === "" ? /* @__PURE__ */ W(Qr, { ...e }) : /* @__PURE__ */ G(U, { children: [e.block.props.showPreview === !1 || !e.children ? /* @__PURE__ */ W($r, { ...e }) : e.children, e.block.props.caption && /* @__PURE__ */ W("figcaption", {
			className: "bn-file-caption",
			children: e.block.props.caption
		})] })
	});
}, $ = (e) => /* @__PURE__ */ G("div", { children: [e.children, /* @__PURE__ */ W("p", { children: e.caption })] }), ti = (e) => {
	let t = qr(e.block.props.url);
	return /* @__PURE__ */ W("audio", {
		className: "bn-audio",
		src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
		controls: !0,
		contentEditable: !1,
		draggable: !1
	});
}, ni = (e) => {
	if (!e.block.props.url) return /* @__PURE__ */ W("p", { children: "Add audio" });
	let t = e.block.props.showPreview ? /* @__PURE__ */ W("audio", { src: e.block.props.url }) : /* @__PURE__ */ W("a", {
		href: e.block.props.url,
		children: e.block.props.name || e.block.props.url
	});
	return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ W(Jr, {
		caption: e.block.props.caption,
		children: t
	}) : /* @__PURE__ */ W($, {
		caption: e.block.props.caption,
		children: t
	}) : t;
}, ri = (e) => /* @__PURE__ */ W(ei, {
	...e,
	buttonIcon: /* @__PURE__ */ W(Ht, { size: 24 }),
	children: /* @__PURE__ */ W(ti, { ...e })
}), ii = Q(Ae, (e) => ({
	meta: { fileBlockAccept: ["audio/*"] },
	render: ri,
	parse: Oe(e),
	toExternalHTML: ni,
	runsBefore: ["file"]
})), ai = Q(je, {
	render: (e) => /* @__PURE__ */ W(ei, { ...e }),
	parse: Le(),
	toExternalHTML: (e) => {
		if (!e.block.props.url) return /* @__PURE__ */ W("p", { children: "Add file" });
		let t = /* @__PURE__ */ W("a", {
			href: e.block.props.url,
			children: e.block.props.name || e.block.props.url
		});
		return e.block.props.caption ? /* @__PURE__ */ W($, {
			caption: e.block.props.caption,
			children: t
		}) : t;
	}
}), oi = (e) => {
	let [t, n] = O(void 0), [r, i] = O(e.block.props.previewWidth), [a, o] = O(!1), s = D(null);
	w(() => {
		let a = (n) => {
			let r, a = "touches" in n ? n.touches[0].clientX : n.clientX;
			r = e.block.props.textAlignment === "center" ? t.handleUsed === "left" ? t.initialWidth + (t.initialClientX - a) * 2 : t.initialWidth + (a - t.initialClientX) * 2 : t.handleUsed === "left" ? t.initialWidth + t.initialClientX - a : t.initialWidth + a - t.initialClientX, i(Math.min(Math.max(r, 64), e.editor.domElement?.firstElementChild?.clientWidth || Number.MAX_VALUE));
		}, o = () => {
			n(void 0), e.editor.updateBlock(e.block, { props: { previewWidth: r } });
		};
		return t && (window.addEventListener("mousemove", a), window.addEventListener("touchmove", a), window.addEventListener("mouseup", o), window.addEventListener("touchend", o)), () => {
			window.removeEventListener("mousemove", a), window.removeEventListener("touchmove", a), window.removeEventListener("mouseup", o), window.removeEventListener("touchend", o);
		};
	}, [
		e,
		t,
		r
	]);
	let c = S(() => {
		e.editor.isEditable && o(!0);
	}, [e.editor.isEditable]), l = S(() => {
		o(!1);
	}, []), u = S((e) => {
		e.preventDefault();
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		n({
			handleUsed: "left",
			initialWidth: s.current.clientWidth,
			initialClientX: t
		});
	}, []), d = S((e) => {
		e.preventDefault();
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		n({
			handleUsed: "right",
			initialWidth: s.current.clientWidth,
			initialClientX: t
		});
	}, []), f = Zr(e.block.id);
	return /* @__PURE__ */ W(ei, {
		...e,
		onMouseEnter: c,
		onMouseLeave: l,
		style: e.block.props.url && !f && e.block.props.showPreview ? { width: r ? `${r}px` : "fit-content" } : void 0,
		children: /* @__PURE__ */ G("div", {
			className: "bn-visual-media-wrapper",
			style: { position: "relative" },
			ref: s,
			children: [
				e.children,
				/* @__PURE__ */ W("div", {
					className: "bn-resize-handle",
					style: {
						left: "4px",
						display: a || t ? "initial" : "none"
					},
					onMouseDown: u,
					onTouchStart: u
				}),
				/* @__PURE__ */ W("div", {
					className: "bn-resize-handle",
					style: {
						right: "4px",
						display: a || t ? "initial" : "none"
					},
					onMouseDown: d,
					onTouchStart: d
				}),
				t && /* @__PURE__ */ W("div", { style: {
					position: "absolute",
					height: "100%",
					width: "100%"
				} })
			]
		})
	});
}, si = (e) => {
	let t = qr(e.block.props.url), n = e.block.props.name || "";
	return /* @__PURE__ */ W("img", {
		className: "bn-visual-media",
		src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
		alt: n,
		contentEditable: !1,
		draggable: !1
	});
}, ci = (e) => {
	if (!e.block.props.url) return /* @__PURE__ */ W("p", { children: "Add image" });
	let t = e.block.props.name || "", n = e.block.props.showPreview ? /* @__PURE__ */ W("img", {
		src: e.block.props.url,
		alt: t,
		width: e.block.props.previewWidth
	}) : /* @__PURE__ */ W("a", {
		href: e.block.props.url,
		children: e.block.props.name || e.block.props.url
	});
	return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ W(Jr, {
		caption: e.block.props.caption,
		children: n
	}) : /* @__PURE__ */ W($, {
		caption: e.block.props.caption,
		children: n
	}) : n;
}, li = (e) => /* @__PURE__ */ W(oi, {
	...e,
	buttonIcon: /* @__PURE__ */ W(bt, { size: 24 }),
	children: /* @__PURE__ */ W(si, { ...e })
}), ui = Q(Me, (e) => ({
	meta: { fileBlockAccept: ["image/*"] },
	render: li,
	parse: qe(e),
	toExternalHTML: ci,
	runsBefore: ["file"]
})), di = { page_break: tn };
function fi(e) {
	return We(e).map((e) => {
		let t = di[e.key];
		return {
			...e,
			icon: /* @__PURE__ */ W(t, { size: 18 })
		};
	});
}
//#endregion
//#region src/blocks/Video/block.tsx
var pi = (e) => {
	let t = qr(e.block.props.url);
	return /* @__PURE__ */ W("video", {
		className: "bn-visual-media",
		src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
		controls: !0,
		contentEditable: !1,
		draggable: !1
	});
}, mi = (e) => {
	if (!e.block.props.url) return /* @__PURE__ */ W("p", { children: "Add video" });
	let t = e.block.props.showPreview ? /* @__PURE__ */ W("video", { src: e.block.props.url }) : /* @__PURE__ */ W("a", {
		href: e.block.props.url,
		children: e.block.props.name || e.block.props.url
	});
	return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ W(Jr, {
		caption: e.block.props.caption,
		children: t
	}) : /* @__PURE__ */ W($, {
		caption: e.block.props.caption,
		children: t
	}) : t;
}, hi = (e) => /* @__PURE__ */ W(oi, {
	...e,
	buttonIcon: /* @__PURE__ */ W(Vt, { size: 24 }),
	children: /* @__PURE__ */ W(pi, { ...e })
}), gi = Q(Fe, (e) => ({
	meta: { fileBlockAccept: ["video/*"] },
	render: hi,
	parse: $e(e),
	toExternalHTML: mi,
	runsBefore: ["file"]
})), _i = (e, t) => {
	if (t.type === "toggled") return !e;
	if (t.type === "childAdded") return !0;
	if (t.type === "lastChildRemoved") return !1;
	throw new we(t);
}, vi = (e) => {
	let { block: t, editor: n, children: r, toggledState: i } = e, [a, o] = oe(_i, (i || Ie).get(t)), s = (e) => {
		(i || Ie).set(n.getBlock(e), !a), o({ type: "toggled" });
	}, c = (e) => {
		(i || Ie).set(e, !0), o({ type: "childAdded" });
	}, u = (e) => {
		(i || Ie).set(e, !1), o({ type: "lastChildRemoved" });
	}, d = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!L(t, e, t.type, { isToggleable: "boolean" }) && !t.props.isToggleable) return 0;
			let n = e.getBlock(t), r = n.children.length || 0;
			return r > d ? a || c(n) : r === 0 && r < d && a && u(n), r;
		}
	});
	return "isToggleable" in t.props && !t.props.isToggleable ? r : /* @__PURE__ */ G("div", { children: [/* @__PURE__ */ G("div", {
		className: "bn-toggle-wrapper",
		"data-show-children": a,
		children: [/* @__PURE__ */ W("button", {
			className: "bn-toggle-button",
			type: "button",
			onMouseDown: (e) => e.preventDefault(),
			onClick: () => s(n.getBlock(t)),
			children: /* @__PURE__ */ W("svg", {
				xmlns: "http://www.w3.org/2000/svg",
				height: "1em",
				viewBox: "0 -960 960 960",
				width: "1em",
				fill: "currentcolor",
				children: /* @__PURE__ */ W("path", { d: "M472-480 332-620q-18-18-18-44t18-44q18-18 44-18t44 18l183 183q9 9 14 21t5 24q0 12-5 24t-14 21L420-252q-18 18-44 18t-44-18q-18-18-18-44t18-44l140-140Z" })
			})
		}), r]
	}), n.isEditable && a && d === 0 && /* @__PURE__ */ W("button", {
		className: "bn-toggle-add-block-button",
		type: "button",
		onClick: () => {
			let e = n.updateBlock(t, { children: [{}] });
			n.setTextCursorPosition(e.children[0].id, "end"), n.focus();
		},
		children: n.dictionary.toggle_blocks.add_block_button
	})] });
}, yi = {
	left: it,
	center: nt,
	right: at,
	justify: rt
}, bi = [
	"left",
	"center",
	"right",
	"justify"
], xi = () => {
	let e = s(), t = f(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block], n = t[0];
			if (L(n, e, n.type, { textAlignment: R.textAlignment })) return {
				textAlignment: n.props.textAlignment,
				blocks: t
			};
			if (t.length === 1 && L(n, e, "table")) {
				let t = e.getExtension(P)?.getCellSelection();
				if (!t || t.cells.length === 0) return;
				let { row: r, col: i } = t.cells[0], a = n.content.rows[r]?.cells[i];
				return a ? {
					textAlignment: V(a).props.textAlignment,
					blocks: [n]
				} : void 0;
			}
		}
	}), i = S((e) => {
		if (r !== void 0) {
			n.focus();
			for (let t of r.blocks) if (L(t, n, t.type, { textAlignment: R.textAlignment }) && z(n, t.type, { textAlignment: R.textAlignment })) n.updateBlock(t, { props: { textAlignment: e } });
			else if (t.type === "table") {
				let r = n.getExtension(P)?.getCellSelection();
				if (!r) continue;
				let i = t.content.rows.map((e) => ({
					...e,
					cells: e.cells.map((e) => V(e))
				}));
				r.cells.forEach(({ row: t, col: n }) => {
					i[t]?.cells[n] && (i[t].cells[n] = {
						...i[t].cells[n],
						props: {
							...i[t].cells[n].props,
							textAlignment: e
						}
					});
				}), n.updateBlock(t, {
					type: "table",
					content: {
						...t.content,
						type: "tableContent",
						rows: i
					}
				}), n.setTextCursorPosition(t);
			}
		}
	}, [n, r]), a = E(() => bi.map((e) => {
		let n = yi[e];
		return {
			text: t.formatting_toolbar[`align_${e}`].label,
			icon: /* @__PURE__ */ W(n, { size: 16 }),
			isSelected: r?.textAlignment === e,
			onClick: () => i(e)
		};
	}), [
		t,
		i,
		r?.textAlignment
	]);
	return r === void 0 ? null : /* @__PURE__ */ W(e.FormattingToolbar.Select, {
		className: "bn-select",
		items: a
	});
}, Si = (e) => {
	let [t, n] = O("none"), r = D(null), i = u(j, { editor: c() }), a = E(() => ({
		display: "flex",
		position: "fixed",
		bottom: 0,
		zIndex: "calc(var(--bn-ui-base-z-index) + 40)",
		transform: t
	}), [t]);
	return w(() => {
		let e = window.visualViewport;
		function t() {
			let t = document.body, r = e.offsetLeft;
			n(`translate(${r}px, ${e.height - t.getBoundingClientRect().height + e.offsetTop}px) scale(${1 / e.scale})`);
		}
		return window.visualViewport.addEventListener("scroll", t), window.visualViewport.addEventListener("resize", t), t(), () => {
			window.visualViewport.removeEventListener("scroll", t), window.visualViewport.removeEventListener("resize", t);
		};
	}, []), !i && r.current ? /* @__PURE__ */ W("div", {
		ref: r,
		style: a,
		dangerouslySetInnerHTML: { __html: r.current.innerHTML }
	}) : /* @__PURE__ */ W("div", {
		ref: r,
		style: a,
		children: /* @__PURE__ */ W(e.formattingToolbar || Rn, {})
	});
};
//#endregion
//#region src/components/TableHandles/hooks/useExtendButtonsPositioning.ts
function Ci(e, t, n) {
	let { refs: r, update: i, context: a, floatingStyles: o } = be({
		open: t,
		placement: e === "addOrRemoveColumns" ? "right" : "bottom",
		middleware: [I({ apply({ rects: t, elements: n }) {
			Object.assign(n.floating.style, e === "addOrRemoveColumns" ? { height: `${t.reference.height}px` } : { width: `${t.reference.width}px` });
		} })]
	}), { isMounted: s, styles: c } = xe(a);
	return w(() => {
		i();
	}, [n, i]), w(() => {
		n !== null && r.setReference({ getBoundingClientRect: () => n });
	}, [
		e,
		n,
		r
	]), E(() => ({
		isMounted: s,
		ref: r.setFloating,
		style: {
			display: "flex",
			...c,
			...o
		}
	}), [
		o,
		s,
		r.setFloating,
		c
	]);
}
function wi(e, t, n) {
	let r = Ci("addOrRemoveRows", t, n), i = Ci("addOrRemoveColumns", e, n);
	return E(() => ({
		addOrRemoveRowsButton: r,
		addOrRemoveColumnsButton: i
	}), [i, r]);
}
//#endregion
//#region src/components/TableHandles/hooks/useTableHandlesPositioning.ts
function Ti(e, t, n) {
	return n && n.draggedCellOrientation === "row" ? new DOMRect(t.x, n.mousePos, t.width, 0) : new DOMRect(t.x, e.y, t.width, e.height);
}
function Ei(e, t, n) {
	return n && n.draggedCellOrientation === "col" ? new DOMRect(n.mousePos, t.y, 0, t.height) : new DOMRect(e.x, t.y, e.width, t.height);
}
function Di(e) {
	return new DOMRect(e.x, e.y, e.width, 0);
}
function Oi(e, t, n, r, i) {
	let { refs: a, update: o, context: s, floatingStyles: c } = be({
		open: t,
		placement: e === "row" ? "left" : e === "col" ? "top" : "bottom-end",
		middleware: [F(e === "row" ? -10 : e === "col" ? -12 : {
			mainAxis: 1,
			crossAxis: -1
		})]
	}), { isMounted: l, styles: u } = xe(s);
	return w(() => {
		o();
	}, [
		n,
		r,
		o
	]), w(() => {
		n === null || r === null || i && e === "cell" || a.setReference({ getBoundingClientRect: () => (e === "row" ? Ti : e === "col" ? Ei : Di)(n, r, i) });
	}, [
		i,
		e,
		n,
		r,
		a
	]), E(() => ({
		isMounted: l,
		ref: a.setFloating,
		style: {
			display: "flex",
			...u,
			...c
		}
	}), [
		c,
		l,
		a.setFloating,
		u
	]);
}
function ki(e, t, n, r) {
	let i = Oi("row", e, t, n, r), a = Oi("col", e, t, n, r), o = Oi("cell", e, t, n, r);
	return E(() => ({
		rowHandle: i,
		colHandle: a,
		cellHandle: o
	}), [
		a,
		i,
		o
	]);
}
//#endregion
//#region src/components/Comments/ThreadsSidebar.tsx
var Ai = x.memo(({ thread: e, selectedThreadId: t, maxCommentsBeforeCollapse: n, referenceText: i }) => {
	let a = r(k), o = S((t) => {
		t.target.closest(".bn-action-toolbar") || a.selectThread(e.id);
	}, [a, e.id]), s = S((e) => {
		if (!e.relatedTarget || e.relatedTarget.closest(".bn-action-toolbar")) return;
		let t = e.target instanceof Node ? e.target : null, n = e.relatedTarget instanceof Node ? e.relatedTarget.closest(".bn-thread") : null;
		(!t || !n || !n.contains(t)) && a.selectThread(void 0);
	}, [a]);
	return /* @__PURE__ */ W(g, {
		thread: e,
		selected: e.id === t,
		referenceText: i,
		maxCommentsBeforeCollapse: n,
		onFocus: o,
		onBlur: s,
		tabIndex: 0
	});
});
function ji(e, t, n) {
	if (t === "recent-activity") return e.sort((e, t) => t.comments[t.comments.length - 1].createdAt.getTime() - e.comments[e.comments.length - 1].createdAt.getTime());
	if (t === "oldest") return e.sort((e, t) => e.createdAt.getTime() - t.createdAt.getTime());
	if (t === "position") return e.sort((e, t) => (n?.get(e.id)?.from || Number.MAX_VALUE) - (n?.get(t.id)?.from || Number.MAX_VALUE));
	throw new we(t);
}
function Mi(e, t) {
	return e.transact((n) => {
		if (!t) return e.dictionary.comments.deleted_reference_text;
		if (n.doc.nodeSize < t.to) return "";
		let r = n.doc.textBetween(t.from, t.to);
		return r.length > 15 ? `${r.slice(0, 15)}…` : r;
	});
}
function Ni(e) {
	let t = c(), { selectedThreadId: n, threadPositions: r } = u(k), i = v();
	return /* @__PURE__ */ W("div", {
		className: "bn-threads-sidebar",
		children: E(() => {
			let n = ji(Array.from(i.values()), e.sort || "position", r), a = [];
			for (let i of n) i.resolved ? (e.filter === "resolved" || e.filter === "all") && a.push({
				thread: i,
				referenceText: Mi(t, r.get(i.id))
			}) : (e.filter === "open" || e.filter === "all") && a.push({
				thread: i,
				referenceText: Mi(t, r.get(i.id))
			});
			return a;
		}, [
			i,
			e.sort,
			e.filter,
			r,
			t
		]).map((r) => /* @__PURE__ */ W(Ai, {
			thread: r.thread,
			selectedThreadId: n,
			editor: t,
			referenceText: r.referenceText,
			maxCommentsBeforeCollapse: e.maxCommentsBeforeCollapse
		}, r.thread.id))
	});
}
//#endregion
//#region src/hooks/useActiveStyles.ts
function Pi(e) {
	let t = i();
	if (e ||= t?.editor, !e) throw Error("'editor' is required, either from BlockNoteContext or as a function argument");
	return l({
		editor: e,
		selector: ({ editor: e }) => e.getActiveStyles()
	});
}
//#endregion
//#region src/hooks/useEditorSelectionBoundingBox.ts
function Fi(e, t) {
	return l({
		editor: t,
		selector: ({ editor: t }) => e ? t.getSelectionBoundingBox() : void 0
	});
}
//#endregion
//#region src/hooks/useFocusWithin.ts
function Ii(e) {
	return e.currentTarget instanceof HTMLElement && e.relatedTarget instanceof HTMLElement ? e.currentTarget.contains(e.relatedTarget) : !1;
}
function Li({ onBlur: e, onFocus: t } = {}) {
	let n = D(null), [r, i] = O(!1), a = D(!1), o = (e) => {
		i(e), a.current = e;
	}, s = (e) => {
		a.current || (o(!0), t?.(e));
	}, c = (t) => {
		a.current && !Ii(t) && (o(!1), e?.(t));
	};
	return w(() => {
		let e = n.current;
		if (e) return e.addEventListener("focusin", s), e.addEventListener("focusout", c), () => {
			e?.removeEventListener("focusin", s), e?.removeEventListener("focusout", c);
		};
	}, [s, c]), {
		ref: n,
		focused: r
	};
}
//#endregion
//#region src/hooks/useSelectedBlocks.ts
function Ri(e) {
	return l({
		editor: e,
		selector: ({ editor: e }) => e.getSelection()?.blocks || [e.getTextCursorPosition().block]
	});
}
//#endregion
//#region src/schema/ReactInlineContentSpec.tsx
function zi(e) {
	return /* @__PURE__ */ W(Yt, {
		as: "span",
		className: "bn-inline-content-section",
		"data-inline-content-type": e.inlineContentType,
		...Object.fromEntries(Object.entries(e.inlineContentProps).filter(([t, n]) => n !== e.propSchema[t].default).map(([e, t]) => [ke(e), t])),
		children: e.children
	});
}
function Bi(e, t) {
	let n = et.create({
		name: e.type,
		inline: !0,
		group: "inline",
		selectable: e.content === "styled",
		atom: e.content === "none",
		draggable: t.meta?.draggable,
		content: e.content === "styled" ? "inline*" : "",
		addAttributes() {
			return Ze(e.propSchema);
		},
		addKeyboardShortcuts() {
			return Ee(e);
		},
		parseHTML() {
			return He(e, t.parse);
		},
		renderHTML({ node: n }) {
			let r = this.options.editor, i = Xe(n, r.schema.inlineContentSchema, r.schema.styleSchema), a = t.toExternalHTML || t.render;
			return Te(X((e) => /* @__PURE__ */ W(a, {
				contentRef: (t) => {
					e(t), t && (t.dataset.editable = "");
				},
				inlineContent: i,
				updateInlineContent: () => {},
				editor: r
			}), r), e.type, n.attrs, e.propSchema);
		},
		addNodeView() {
			let n = this.options.editor;
			return (r) => Qt((r) => {
				let i = $t().nodeViewContentRef;
				if (!i) throw Error("nodeViewContentRef is not set");
				let a = t.render;
				return /* @__PURE__ */ W(zi, {
					inlineContentProps: r.node.attrs,
					inlineContentType: e.type,
					propSchema: e.propSchema,
					children: /* @__PURE__ */ W(a, {
						contentRef: (e) => {
							i(e), e && (e.dataset.editable = "");
						},
						editor: n,
						inlineContent: Xe(r.node, n.schema.inlineContentSchema, n.schema.styleSchema),
						updateInlineContent: (e) => {
							let t = Je([e], n.pmSchema), i = r.getPos();
							i !== void 0 && n.transact((e) => e.replaceWith(i, i + r.node.nodeSize, t));
						}
					})
				});
			}, {
				className: "bn-ic-react-node-view-renderer",
				as: "span"
			})(r);
		}
	});
	return Ne(e, {
		...t,
		node: n,
		render(n, r, i) {
			let a = t.render;
			return X((t) => /* @__PURE__ */ W(zi, {
				inlineContentProps: n.props,
				inlineContentType: e.type,
				propSchema: e.propSchema,
				children: /* @__PURE__ */ W(a, {
					contentRef: (e) => {
						t(e), e && (e.dataset.editable = "");
					},
					editor: i,
					inlineContent: n,
					updateInlineContent: r
				})
			}), i);
		},
		toExternalHTML(n, r) {
			let i = t.toExternalHTML || t.render;
			return X((t) => /* @__PURE__ */ W(zi, {
				inlineContentProps: n.props,
				inlineContentType: e.type,
				propSchema: e.propSchema,
				children: /* @__PURE__ */ W(i, {
					contentRef: (e) => {
						t(e), e && (e.dataset.editable = "");
					},
					editor: r,
					inlineContent: n,
					updateInlineContent: () => {}
				})
			}), r);
		}
	});
}
//#endregion
//#region src/schema/ReactStyleSpec.tsx
function Vi(e, t) {
	let n = Jt.create({
		name: e.type,
		addAttributes() {
			return Qe(e.propSchema);
		},
		parseHTML() {
			return Ke(e);
		},
		renderHTML({ mark: n }) {
			let r = t.render;
			return De(X((t) => /* @__PURE__ */ W(r, {
				editor: this.options.editor,
				value: e.propSchema === "boolean" ? void 0 : n.attrs.stringValue,
				contentRef: (e) => {
					t(e), e && (e.dataset.editable = "");
				}
			}), this.options.editor), e.type, n.attrs.stringValue, e.propSchema);
		},
		addMarkView() {
			let n = this.options.editor;
			return (r) => {
				let i = Zt((r) => {
					let i = C(Xt).markViewContentRef;
					if (!i) throw Error("markViewContentRef is not set");
					let a = t.render;
					return /* @__PURE__ */ W(a, {
						editor: n,
						contentRef: (e) => {
							i(e), e && (e.dataset.markViewContent = "");
						},
						value: e.propSchema === "boolean" ? void 0 : r.mark.attrs.stringValue
					});
				})(r);
				return i.didMountContentDomElement = !0, i;
			};
		}
	});
	return Pe(e, {
		...t,
		mark: n,
		render(n, r) {
			let i = t.render;
			return De(X((e) => /* @__PURE__ */ W(i, {
				editor: r,
				value: n,
				contentRef: (t) => {
					e(t), t && (t.dataset.editable = "");
				}
			}), r), e.type, n, e.propSchema);
		},
		toExternalHTML(n, r) {
			let i = t.render;
			return De(X((e) => /* @__PURE__ */ W(i, {
				editor: r,
				value: n,
				contentRef: (t) => {
					e(t), t && (t.dataset.editable = "");
				}
			}), r), e.type, n, e.propSchema);
		}
	});
}
//#endregion
//#region src/util/elementOverflow.ts
function Hi(e, t) {
	let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.top < r.top, a = n.bottom > r.bottom;
	return i && a ? "both" : i ? "top" : a ? "bottom" : "none";
}
//#endregion
//#region src/util/mergeRefs.ts
function Ui(e) {
	return (t) => {
		e.forEach((e) => {
			typeof e == "function" ? e(t) : e != null && (e.current = t);
		});
	};
}
//#endregion
export { Kn as AddBlockButton, Sr as AddButton, On as AddCommentButton, Dn as AddCommentButtonInner, Qr as AddFileButton, kn as AddTiptapCommentButton, ri as AudioBlock, ti as AudioPreview, ni as AudioToExternalHTML, Y as BasicTextStyleButton, qn as BlockColorsItem, Z as BlockContentWrapper, a as BlockNoteContext, Mr as BlockNoteDefaultUI, Gr as BlockNoteViewEditor, Wr as BlockNoteViewRaw, nn as BlockPopover, En as BlockTypeSelect, vr as ColorPickerButton, mn as ColorStyleButton, _ as Comment, m as Comments, t as ComponentsContext, vn as CreateLinkButton, Cr as DeleteButton, Vn as DeleteLinkButton, Qn as DragHandleButton, Zn as DragHandleMenu, Hn as EditLinkButton, gn as EditLinkMenuItems, rn as EmbedTab, Si as ExperimentalMobileFormattingToolbarController, _r as ExtendButton, Jr as FigureWithCaption, ei as FileBlockWrapper, yn as FileCaptionButton, bn as FileDeleteButton, jn as FileDownloadButton, $r as FileNameWithIcon, on as FilePanel, sn as FilePanelController, Mn as FilePreviewButton, xn as FileRenameButton, Sn as FileReplaceButton, ee as FloatingComposer, te as FloatingComposerController, b as FloatingThreadController, Rn as FormattingToolbar, Bn as FormattingToolbarController, p as GenericPopover, sr as GridSuggestionMenuController, or as GridSuggestionMenuWrapper, li as ImageBlock, si as ImagePreview, ci as ImageToExternalHTML, zi as InlineContentWrapper, Wn as LinkToolbar, Gn as LinkToolbarController, $ as LinkWithCaption, Cn as NestBlockButton, Un as OpenLinkButton, o as PositionPopover, ii as ReactAudioBlock, ai as ReactFileBlock, ui as ReactImageBlock, gi as ReactVideoBlock, Jn as RemoveBlockItem, oi as ResizableFileBlockWrapper, $n as SideMenu, er as SideMenuController, yr as SplitButton, hr as SuggestionMenuController, fr as SuggestionMenuWrapper, xr as TableCellButton, br as TableCellMenu, Pn as TableCellMergeButton, Xn as TableColumnHeaderItem, Or as TableHandle, Dr as TableHandleMenu, kr as TableHandlesController, Yn as TableRowHeaderItem, In as TextAlignButton, xi as TextAlignSelect, g as Thread, Ni as ThreadsSidebar, vi as ToggleWrapper, wn as UnnestBlockButton, an as UploadTab, hi as VideoBlock, pi as VideoPreview, mi as VideoToExternalHTML, Tn as blockTypeSelectItems, Q as createReactBlockSpec, Bi as createReactInlineContentSpec, Vi as createReactStyleSpec, Hi as elementOverflow, tr as getDefaultReactEmojiPickerItems, mr as getDefaultReactSlashMenuItems, Ln as getFormattingToolbarItems, n as getMountedBoundingClientRectCache, fi as getPageBreakReactSlashMenuItems, Mi as getReferenceText, Ui as mergeRefs, Pi as useActiveStyles, i as useBlockNoteContext, c as useBlockNoteEditor, rr as useCloseSuggestionMenuNoItems, s as useComponentsContext, d as useCreateBlockNote, f as useDictionary, Nr as useEditorChange, e as useEditorDOMElement, Fi as useEditorSelectionBoundingBox, Pr as useEditorSelectionChange, l as useEditorState, wi as useExtendButtonsPositioning, r as useExtension, u as useExtensionState, Li as useFocusWithin, ar as useGridSuggestionMenuKeyboardNavigation, ir as useLoadSuggestionMenuItems, Yr as useOnUploadEnd, Xr as useOnUploadStart, Fr as usePrefersColorScheme, qr as useResolveUrl, Ri as useSelectedBlocks, lr as useSuggestionMenuKeyboardHandler, dr as useSuggestionMenuKeyboardNavigation, ki as useTableHandlesPositioning, v as useThreads, Zr as useUploadLoading, y as useUser, h as useUsers };

//# sourceMappingURL=blocknote-react.js.map